/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2), __webpack_require__(5), __webpack_require__(6), __webpack_require__(8), __webpack_require__(3), __webpack_require__(10), __webpack_require__(14), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_super_menu, _swiper, filter, _login, _cart, _drawer, product, combo, info) {
  "use strict";

  filter = _interopRequireWildcard(filter);
  product = _interopRequireWildcard(product);
  combo = _interopRequireWildcard(combo);
  info = _interopRequireWildcard(info);
  function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
  /* Para minificar o arquivo rode
   gulp watchJs --fn=custom --src=catalog/view/theme/rosealianca_2026/javascript
   */

  // Importando do novo arquivo

  // Expõe globalmente as funções do Drawer
  window.openDrawer = _drawer.openDrawer;
  window.closeDrawer = _drawer.closeDrawer;
  window.closeAll = _drawer.closeAll;
  window.closeSuperMenu = _super_menu.closeSuperMenu;
  window.openSuperMenuMobile = _super_menu.openSuperMenuMobile;
  var header = document.querySelector(".header");
  var navButtons = document.querySelectorAll(".header__nav-button");
  function toggleSuperMenuCategory(event) {
    var button = event.currentTarget;
    if (button.classList.contains("active")) {
      (0, _super_menu.closeSuperMenu)();
      return;
    }
    (0, _super_menu.openSuperMenuCategory)(event);
  }
  navButtons.forEach(function (button) {
    button.addEventListener("click", toggleSuperMenuCategory);
  });
  var menuButton = document.querySelector(".header__menu-trigger");
  if (menuButton) {
    menuButton.addEventListener("click", _super_menu.openSuperMenuMobile);
  }
  var searchButtons = document.querySelector(".header__icon-button--search");
  if (searchButtons) {
    searchButtons.addEventListener("click", _super_menu.openSuperMenuSearch);
  }
  var searchMobileButtons = document.querySelector(".header__icon-button--search-mobile");
  if (searchMobileButtons) {
    searchMobileButtons.addEventListener("click", _super_menu.openSuperMenuSearchMobile);
  }
  var loginButton = document.querySelector("#header-login-button");
  if (loginButton) {
    loginButton.addEventListener("click", function (e) {
      requestAnimationFrame(function () {
        var drawer = document.getElementById("drawer-login");
        if (drawer && drawer.dataset.state === "open") {
          (0, _login.checkLoginAndUpdateLoginDrawer)();
        }
      });
    });
  }
  var registerAction = document.getElementById("drawer-register-action");
  if (registerAction) {
    registerAction.addEventListener("click", function () {
      if (registerAction.href.includes("/logout")) {
        (0, _login.clearLoginCache)();
      }
    });
  }
  var searchCloseButton = document.querySelector(".header__search-close");
  searchCloseButton.addEventListener("click", _super_menu.closeSuperMenu);
  document.addEventListener("click", function (e) {
    var button = e.target.closest("[data-drawer-target]");
    if (button) {
      var drawerId = button.dataset.drawerTarget;
      var drawer = document.getElementById(drawerId);
      if (drawer && drawer.dataset.state === "open") {
        (0, _drawer.closeDrawer)(drawerId);
      } else {
        (0, _drawer.openDrawer)(drawerId); // sem o "true" — não existe mais toggle de ícone
      }
      return;
    }
    var closeBtn = e.target.closest("[data-drawer-close]");
    if (closeBtn) {
      (0, _drawer.closeAll)();
      return;
    }
  });
  document.querySelectorAll(".drawer-overlay, .super-menu-overlay").forEach(function (overlay) {
    overlay.addEventListener("click", function () {
      (0, _drawer.closeAll)();
      header.dataset.search = "closed";
    });
  });
  var swipers = document.querySelectorAll("[data-swiper-config]");
  swipers.forEach(function (swiperElement) {
    if (swiperElement.classList.contains("swiper-initialized")) {
      return;
    }
    var instance = (0, _swiper.initSwiper)(swiperElement);
  });
  var footerTitles = document.querySelectorAll(".footer__col-title");
  footerTitles.forEach(function (title) {
    title.addEventListener("click", function () {
      // Encontra o elemento pai com a classe .footer__col
      var footerCol = title.closest(".footer__col");
      if (footerCol) {
        // Adiciona o atributo 'open' se não existir, ou remove se já existir
        footerCol.toggleAttribute("open");
      }
    });
  });
  function renderListButtons() {
    // --- PARTE 1: Botões das Abas (Tabs) ---
    var tabNavItems = document.querySelectorAll(".tabs__nav-item");
    tabNavItems.forEach(function (navItem) {
      var url = navItem.getAttribute("data-url");
      var targetPanelId = navItem.getAttribute("data-list");
      if (url && url.trim() !== "") {
        var panel = document.getElementById(targetPanelId);
        if (panel) {
          // Evita duplicar o botão se a função rodar mais de uma vez
          if (panel.querySelector(".product-list-link-button")) return;
          var linkButton = document.createElement("a");
          linkButton.className = "product-list-link-button";
          linkButton.href = "/".concat(url);
          linkButton.innerHTML = "\n          <span>Ver mais</span>\n          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"5\" height=\"7\" viewBox=\"0 0 5 7\" fill=\"none\">\n            <path d=\"M0.198 6.858C0.09 6.858 0.036 6.786 0.036 6.642C0.036 6.618 0.042 6.594 0.054 6.57C0.066 6.534 0.078 6.504 0.09 6.48C0.426 5.964 0.75 5.526 1.062 5.166C1.386 4.806 1.692 4.5 1.98 4.248C2.28 3.984 2.562 3.75 2.826 3.546C2.898 3.486 2.934 3.444 2.934 3.42C2.934 3.384 2.898 3.342 2.826 3.294C2.562 3.09 2.28 2.868 1.98 2.628C1.692 2.376 1.386 2.076 1.062 1.728C0.75 1.368 0.426 0.935999 0.09 0.431999C0.066 0.383999 0.042 0.342 0.018 0.306C0.00599998 0.258 0 0.21 0 0.162C0 0.054 0.036 0 0.108 0C0.216 0 0.318 0.0419995 0.414 0.125999C0.51 0.209999 0.582 0.276 0.63 0.323999C0.942 0.623999 1.242 0.894 1.53 1.134C1.83 1.374 2.136 1.608 2.448 1.836C2.76 2.052 3.096 2.28 3.456 2.52C3.828 2.748 4.242 3 4.698 3.276C4.734 3.288 4.752 3.33 4.752 3.402C4.752 3.486 4.722 3.582 4.662 3.69C4.602 3.798 4.524 3.876 4.428 3.924C4.164 4.044 3.882 4.194 3.582 4.374C3.282 4.542 2.97 4.74 2.646 4.968C2.334 5.184 2.016 5.424 1.692 5.688C1.368 5.952 1.05 6.234 0.738 6.534C0.69 6.582 0.618 6.648 0.522 6.732C0.426 6.816 0.318 6.858 0.198 6.858Z\" fill=\"currentColor\"/>\n          </svg>\n        ";
          panel.appendChild(linkButton);
        }
      }
    });

    // --- PARTE 2: Botões dos Módulos de Produto (.product_module) ---
    var productModules = document.querySelectorAll(".product_module");
    productModules.forEach(function (module) {
      // Busca o link <a> que esteja dentro do .heading-title desse módulo específico
      var titleLink = module.querySelector(".heading-title a");
      if (titleLink) {
        var url = titleLink.getAttribute("href");

        // Verifica se o href existe e não é apenas um "#" ou vazio
        if (url && url.trim() !== "" && url !== "#") {
          // Evita duplicar o botão caso a função seja reexecutada
          if (module.querySelector(".product-list-link-button")) return;
          var linkButton = document.createElement("a");
          linkButton.className = "product-list-link-button"; // Mantém a classe para usar o mesmo CSS
          linkButton.href = url; // Aqui usamos o href direto do link original do título
          linkButton.innerHTML = "\n          <span>Ver mais</span>\n          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"5\" height=\"7\" viewBox=\"0 0 5 7\" fill=\"none\">\n            <path d=\"M0.198 6.858C0.09 6.858 0.036 6.786 0.036 6.642C0.036 6.618 0.042 6.594 0.054 6.57C0.066 6.534 0.078 6.504 0.09 6.48C0.426 5.964 0.75 5.526 1.062 5.166C1.386 4.806 1.692 4.5 1.98 4.248C2.28 3.984 2.562 3.75 2.826 3.546C2.898 3.486 2.934 3.444 2.934 3.42C2.934 3.384 2.898 3.342 2.826 3.294C2.562 3.09 2.28 2.868 1.98 2.628C1.692 2.376 1.386 2.076 1.062 1.728C0.75 1.368 0.426 0.935999 0.09 0.431999C0.066 0.383999 0.042 0.342 0.018 0.306C0.00599998 0.258 0 0.21 0 0.162C0 0.054 0.036 0 0.108 0C0.216 0 0.318 0.0419995 0.414 0.125999C0.51 0.209999 0.582 0.276 0.63 0.323999C0.942 0.623999 1.242 0.894 1.53 1.134C1.83 1.374 2.136 1.608 2.448 1.836C2.76 2.052 3.096 2.28 3.456 2.52C3.828 2.748 4.242 3 4.698 3.276C4.734 3.288 4.752 3.33 4.752 3.402C4.752 3.486 4.722 3.582 4.662 3.69C4.602 3.798 4.524 3.876 4.428 3.924C4.164 4.044 3.882 4.194 3.582 4.374C3.282 4.542 2.97 4.74 2.646 4.968C2.334 5.184 2.016 5.424 1.692 5.688C1.368 5.952 1.05 6.234 0.738 6.534C0.69 6.582 0.618 6.648 0.522 6.732C0.426 6.816 0.318 6.858 0.198 6.858Z\" fill=\"currentColor\"/>\n          </svg>\n        ";

          // Insere o botão ao final do próprio container .product_module
          module.appendChild(linkButton);
        }
      }
    });
  }
  $(function () {
    (0, _cart.updateCartDrawer)();
    $(".drawer__body").on("click", ".drawer-cart__product-remove-button", function (e) {
      e.preventDefault();
      var productKey = $(this).attr("data-product-key");
      (0, _cart.deleteCartItem)(productKey);
    });
    $(".drawer__body").on("click", "#drawer-cart-zip-code-button", function (e) {
      e.preventDefault();
      (0, _cart.calculateFreight)();
    });
    renderListButtons();
  });
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _swiper, _drawer, _number_formatter) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.closeSuperMenu = closeSuperMenu;
  _exports.openSuperMenu = openSuperMenu;
  _exports.openSuperMenuCategory = openSuperMenuCategory;
  _exports.openSuperMenuMobile = openSuperMenuMobile;
  _exports.openSuperMenuSearch = openSuperMenuSearch;
  _exports.openSuperMenuSearchMobile = openSuperMenuSearchMobile;
  _exports.setMobileInfoData = setMobileInfoData;
  _exports.setSuperMenuInfoData = setSuperMenuInfoData;
  function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
  function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
  function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
  function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
  function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
  // ============================================================================
  // FUNÇÕES DE CONTROLE DO SUPER MENU (DRAWER)
  // ============================================================================

  var superMenu = document.getElementById("super-menu");
  var superMenuMobile = document.getElementById("super-menu-mobile");
  var superMenuSearchMobile = document.getElementById("super-menu-search-mobile");
  var header = document.querySelector(".header");
  var tabsWrapper = superMenu === null || superMenu === void 0 ? void 0 : superMenu.querySelector(".super-menu__tabs-swiper .swiper-wrapper");
  var superMenuMobileContent = superMenuMobile === null || superMenuMobile === void 0 ? void 0 : superMenuMobile.querySelector(".super-menu__mobile-content");
  var superMenuSearchMobileContent = superMenuSearchMobile === null || superMenuSearchMobile === void 0 ? void 0 : superMenuSearchMobile.querySelector(".super-menu__mobile-content");
  var superMenuSearchMobileInput = superMenuSearchMobile === null || superMenuSearchMobile === void 0 ? void 0 : superMenuSearchMobile.querySelector(".header__search-input");
  var tabsSwiperInstance = null;
  var productsSwiperInstance = null;
  var isProductsLoading = false;
  var inputSearchDebounceTimer = null;
  var currentFlow = null; // guarda o fluxo ativo ("category" | "suggestion_search" | "inputSearch")

  var isMobileProductsLoading = false;
  var mobileInputSearchDebounceTimer = null;
  var superMenuInfoData = {};
  function setSuperMenuInfoData(data) {
    superMenuInfoData = data || {};
  }
  window.setSuperMenuInfoData = setSuperMenuInfoData;
  var productCache = {}; // Cache em memória para evitar requisições duplicadas

  function handleHeaderTransparency() {
    if (!header) return;
    var isAtTop = window.scrollY < 30;
    var isHomePage = document.body.classList.contains("page-common-home");

    // Ativa a transparência APENAS se estiver no topo E for a Home
    header.classList.toggle("header--transparent", isAtTop && isHomePage);
  }

  // Executa ao scrollar a página
  window.addEventListener("scroll", handleHeaderTransparency);

  // ----------------------------------------------------------------------------
  // DESKTOP — TRAVA DE TRIGGERS DURANTE FETCH
  // ----------------------------------------------------------------------------

  function setDesktopTriggersLocked(locked) {
    var tabs = (superMenu === null || superMenu === void 0 ? void 0 : superMenu.querySelectorAll(".super-menu__tab-trigger")) || [];
    tabs.forEach(function (tab) {
      tab.disabled = locked;
      tab.classList.toggle("is-disabled", locked);
    });
    var navButtons = document.querySelectorAll(".header__nav-button");
    navButtons.forEach(function (btn) {
      btn.disabled = locked;
      btn.classList.toggle("is-disabled", locked);
    });
  }

  /**
   * FLUXO: Ao clicar em uma Categoria Principal
   */
  function openSuperMenuCategory(event) {
    if (!tabsWrapper || isProductsLoading) return;
    var button = event.currentTarget;
    var categoryId = button.dataset.categoryId;
    var categoryLink = button.dataset.categoryLink;
    tabsWrapper.innerHTML = "";

    // Categorias informativas podem definir um rótulo próprio pra 1ª aba
    var infoData = superMenuInfoData[categoryId];
    var firstTabLabel = (infoData === null || infoData === void 0 ? void 0 : infoData.tabLabel) || "Todos os Produtos";

    // Injeta o primeiro índice fixo
    var firstFixedTab = "\n    <div class=\"swiper-slide header__nav-subitem\">\n      <button type=\"button\" class=\"header__nav-sublink super-menu__tab-trigger\" data-href=\"".concat(categoryLink, "\" data-category-id=\"").concat(categoryId, "\">\n        ").concat(firstTabLabel, "\n      </button>\n    </div>\n  ");
    tabsWrapper.insertAdjacentHTML("beforeend", firstFixedTab);

    // Injeta as subcategorias vindas do template PHP (se houver)
    var template = document.getElementById("category-".concat(categoryId, "-subcategory"));
    if (template) {
      var clone = template.content.cloneNode(true);
      tabsWrapper.appendChild(clone);
    }
    openSuperMenu("category", button);
  }

  /**
   * FLUXO: Ao abrir a Busca
   */
  function openSuperMenuSearch(event) {
    if (!tabsWrapper) return;
    renderSuggestionSearchTabsTitle();
    openSuperMenu("suggestion_search", event === null || event === void 0 ? void 0 : event.currentTarget); // já chama openDrawer internamente
    header.dataset.search = "open"; // fica aqui, é exclusivo da busca
  }
  function renderSuggestionSearchTabsTitle() {
    if (!tabsWrapper) return;
    tabsWrapper.innerHTML = "";
    // Injeta o template de termos mais pesquisados
    var template = document.getElementById("super-menu-suggestion-search-template");
    if (template) {
      var clone = template.content.cloneNode(true);
      tabsWrapper.appendChild(clone);
    }
  }
  function renderInputSearchTabsTitle() {
    var hasResult = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!tabsWrapper) return;
    if (hasResult) {
      tabsWrapper.innerHTML = "\n    <div class=\"swiper-slide header__nav-subitem\">\n      <div class=\"super-menu__tab-title\">\n        <h4 class=\"super-menu__tab-main-title\">Resultados</h4>\n      </div>\n    </div>\n  ";
    } else {
      tabsWrapper.innerHTML = "\n    <div class=\"swiper-slide header__nav-subitem\">\n      <div class=\"super-menu__tab-title\">\n        <h4 class=\"super-menu__tab-main-title\">N\xE3o encontramos sua pesquisa.</h4>\n        <span class=\"super-menu__tab-sub-title\">Mas voc\xEA pode gostar de</span>\n      </div>\n    </div>\n  ";
    }
  }
  function resetSearchToSuggestions() {
    updateSeeMoreLink(null);
    renderSuggestionSearchTabsTitle();
    currentFlow = "suggestion_search";
    activateFirstTab("suggestion_search");
  }
  function inputSearchFlow(_x) {
    return _inputSearchFlow.apply(this, arguments);
  }
  function _inputSearchFlow() {
    _inputSearchFlow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(query) {
      var trimmedQuery, href, products, hasResult;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (!isProductsLoading) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            trimmedQuery = query.trim();
            if (trimmedQuery) {
              _context2.n = 2;
              break;
            }
            showNoProductsState();
            updateSeeMoreLink(null);
            return _context2.a(2);
          case 2:
            isProductsLoading = true;
            setDesktopTriggersLocked(true);
            _context2.p = 3;
            currentFlow = "inputSearch";
            showLoadingProductsState();
            href = "/busca?search=".concat(encodeURIComponent(trimmedQuery));
            _context2.n = 4;
            return fetchProductsSearch(trimmedQuery);
          case 4:
            products = _context2.v;
            hasResult = true; // Sem resultado na busca: cai para a lista de sugestões (fetchSuggestionSearch)
            if (products.length) {
              _context2.n = 6;
              break;
            }
            hasResult = false;
            _context2.n = 5;
            return fetchSuggestionSearch();
          case 5:
            products = _context2.v;
          case 6:
            renderInputSearchTabsTitle(hasResult);
            renderSuperMenuProducts(products, hasResult ? href : null);
          case 7:
            _context2.p = 7;
            isProductsLoading = false;
            setDesktopTriggersLocked(false);
            return _context2.f(7);
          case 8:
            return _context2.a(2);
        }
      }, _callee2, null, [[3,, 7, 8]]);
    }));
    return _inputSearchFlow.apply(this, arguments);
  }
  function categoryFlow(_x2) {
    return _categoryFlow.apply(this, arguments);
  }
  function _categoryFlow() {
    _categoryFlow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(activeTab) {
      var id, href, infoData, products;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (!isProductsLoading) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            id = activeTab.dataset.categoryId;
            href = activeTab.dataset.href; // Categoria "informativa" (história, descubra, etc.) — não busca produtos
            infoData = superMenuInfoData[id];
            if (!infoData) {
              _context3.n = 2;
              break;
            }
            renderSuperMenuInfoPane(infoData);
            return _context3.a(2);
          case 2:
            isProductsLoading = true;
            setDesktopTriggersLocked(true);
            _context3.p = 3;
            showLoadingProductsState();
            _context3.n = 4;
            return fetchProductsByCategory(id);
          case 4:
            products = _context3.v;
            renderSuperMenuProducts(products, href);
          case 5:
            _context3.p = 5;
            isProductsLoading = false;
            setDesktopTriggersLocked(false);
            return _context3.f(5);
          case 6:
            return _context3.a(2);
        }
      }, _callee3, null, [[3,, 5, 6]]);
    }));
    return _categoryFlow.apply(this, arguments);
  }
  function suggestionSearchFlow(_x3) {
    return _suggestionSearchFlow.apply(this, arguments);
  }
  /**
   * Abre o menu principal e gerencia a inicialização das abas via initSwiper
   */
  function _suggestionSearchFlow() {
    _suggestionSearchFlow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(activeTab) {
      var id, search, href, products;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            if (!isProductsLoading) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2);
          case 1:
            isProductsLoading = true;
            setDesktopTriggersLocked(true);
            _context4.p = 2;
            id = activeTab.dataset.id;
            search = activeTab.dataset.search;
            showLoadingProductsState();
            href = null;
            products = [];
            if (!(id === "suggestion-search")) {
              _context4.n = 4;
              break;
            }
            _context4.n = 3;
            return fetchSuggestionSearch();
          case 3:
            products = _context4.v;
            _context4.n = 6;
            break;
          case 4:
            if (!search) {
              _context4.n = 6;
              break;
            }
            href = "/busca?search=".concat(search);
            _context4.n = 5;
            return fetchProductsSearch(search);
          case 5:
            products = _context4.v;
          case 6:
            renderSuperMenuProducts(products, href);
          case 7:
            _context4.p = 7;
            isProductsLoading = false;
            setDesktopTriggersLocked(false);
            return _context4.f(7);
          case 8:
            return _context4.a(2);
        }
      }, _callee4, null, [[2,, 7, 8]]);
    }));
    return _suggestionSearchFlow.apply(this, arguments);
  }
  function openSuperMenu(flow) {
    var triggerButton = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!superMenu || !header || !tabsWrapper) return;
    currentFlow = flow;
    (0, _drawer.openDrawer)("super-menu", triggerButton);

    // Limpa e destrói a instância anterior das abas para evitar conflitos
    if (tabsSwiperInstance) tabsSwiperInstance.destroy(true, true);

    // Inicializa o Swiper de Abas usando a sua função genérica
    var tabsContainer = superMenu.querySelector(".super-menu__tabs-swiper");
    if (tabsContainer) {
      tabsSwiperInstance = (0, _swiper.initSwiper)(tabsContainer, {
        navigation: {
          nextEl: superMenu.querySelector(".super-menu__tabs-navigation .swiper-button-next"),
          prevEl: superMenu.querySelector(".super-menu__tabs-navigation .swiper-button-prev")
        }
      });
    }

    // Gerencia o clique nas abas (Event Delegation)
    tabsContainer.onclick = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        var clickedTab;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              clickedTab = e.target.closest(".super-menu__tab-trigger");
              if (!(!clickedTab || isProductsLoading)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              superMenu.querySelectorAll(".super-menu__tab-trigger").forEach(function (tab) {
                return tab.classList.remove("active");
              });
              clickedTab.classList.add("active");
              if (currentFlow === "category") {
                categoryFlow(clickedTab);
              }
              if (currentFlow === "suggestion_search") {
                suggestionSearchFlow(clickedTab);
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x4) {
        return _ref.apply(this, arguments);
      };
    }();

    // Ativa automaticamente a primeira aba do menu
    if (flow !== "inputSearch") {
      activateFirstTab(flow);
    }
  }

  // ----------------------------------------------------------------------------
  // MOBILE — MENU DE CATEGORIAS
  // ----------------------------------------------------------------------------

  function loadFirstMobileCategory() {
    var firstItem = superMenuMobile === null || superMenuMobile === void 0 ? void 0 : superMenuMobile.querySelector(".super-menu__mobile-list > .super-menu__mobile-item");
    var firstTrigger = firstItem === null || firstItem === void 0 ? void 0 : firstItem.querySelector(":scope > .super-menu__mobile-result-trigger, :scope > .super-menu__mobile-item-button");
    if (!firstTrigger) return;
    activateMobileTrigger(firstTrigger);

    // Se for categoria com submenu, expande visualmente
    var hasSubmenu = firstItem.querySelector(":scope > .super-menu__mobile-sub-list");
    if (hasSubmenu) {
      firstTrigger.setAttribute("aria-expanded", "true");
      firstItem.setAttribute("open", "");
    }
    mobileResultFlow(firstTrigger);
  }
  function openSuperMenuMobile(event) {
    if (!superMenuMobile) return;
    var isOpen = superMenuMobile.dataset.state === "open";
    if (isOpen) {
      (0, _drawer.closeDrawer)("super-menu-mobile");
      return;
    }
    var triggerButton = (event === null || event === void 0 ? void 0 : event.currentTarget) || document.querySelector(".header__menu-trigger--mobile");
    (0, _drawer.openDrawer)("super-menu-mobile", triggerButton);
    loadFirstMobileCategory();
  }

  // ----------------------------------------------------------------------------
  // MOBILE — MENU DE BUSCA
  // ----------------------------------------------------------------------------

  function loadFirstMobileSearchSuggestion() {
    var firstTrigger = superMenuSearchMobile === null || superMenuSearchMobile === void 0 ? void 0 : superMenuSearchMobile.querySelector(".super-menu__mobile-list > .super-menu__mobile-item > .super-menu__mobile-result-trigger");
    if (!firstTrigger) return;
    activateMobileTrigger(firstTrigger);
    mobileResultFlow(firstTrigger);
  }
  function openSuperMenuSearchMobile(event) {
    if (!superMenuSearchMobile) return;
    var isOpen = superMenuSearchMobile.dataset.state === "open";
    if (isOpen) {
      (0, _drawer.closeDrawer)("super-menu-search-mobile");
      return;
    }
    (0, _drawer.openDrawer)("super-menu-search-mobile", event === null || event === void 0 ? void 0 : event.currentTarget);
    if (superMenuSearchMobileInput) {
      superMenuSearchMobileInput.value = "";
    }
    loadFirstMobileSearchSuggestion();
  }
  function closeSuperMenu() {
    (0, _drawer.closeAll)(); // fecha super-menu, super-menu-mobile, super-menu-search-mobile, cart, login — tudo junto
    if (header) {
      header.dataset.search = "closed"; // atributo específico do super menu, mantido separado
    }
  }
  function showLoadingProductsState() {
    var panesContainer = superMenu.querySelector(".super-menu__panes");
    panesContainer.innerHTML = "\n    <div class=\"super-menu__loading\" style=\"display: flex; justify-content: center; align-items: center; width: 100%; min-height: 200px; color: #666; font-weight: 500;\">\n      Carregando produtos...\n    </div>\n  ";
  }
  function showNoProductsState() {
    var panesContainer = superMenu.querySelector(".super-menu__panes");
    panesContainer.innerHTML = "\n    <div class=\"super-menu__empty\" style=\"display: flex; justify-content: center; align-items: center; width: 100%; min-height: 200px; color: #666; font-weight: 500;\">\n      Nenhum produto encontrado.\n    </div>\n  ";
  }

  /**
   * Cria o elemento de avaliação (estrelas) para um produto.
   * Sempre renderiza 5 estrelas. Se não houver rating válido, todas ficam vazias.
   * @param {number|string} rating - valor de 0 a 5 (pode vir decimal, ex: 3.7)
   * @returns {HTMLElement} div.rating pronta para inserir
   */
  function createRatingElement(rating) {
    var numericRating = Number(rating);
    var hasValidRating = !isNaN(numericRating) && numericRating > 0;

    // Arredonda para o inteiro mais próximo (0 a 5); sem rating válido = 0 estrelas cheias
    var filledStars = hasValidRating ? Math.min(5, Math.max(0, Math.round(numericRating))) : 0;
    var ratingDiv = document.createElement("div");
    ratingDiv.className = "rating product-rating offset-top-20";
    for (var i = 0; i < 5; i++) {
      var star = document.createElement("span");
      star.className = i < filledStars ? "mdi mdi-star" : "mdi mdi-star-outline";
      ratingDiv.appendChild(star);
    }
    return ratingDiv;
  }

  /**
   * Monta os produtos e inicializa o swiper de produtos usando o initSwiper
   */
  function renderSuperMenuProducts(products, href) {
    var panesContainer = superMenu.querySelector(".super-menu__panes");
    if (!panesContainer) return;
    var productList = Array.isArray(products) ? products : [];
    var paneTemplate = document.getElementById("header-pane-template");
    var productCardTemplate = document.getElementById("super-menu-product-card-template");
    if (!paneTemplate || !productCardTemplate) return;
    if (!productList.length) {
      showNoProductsState();
      updateSeeMoreLink(href);
      return;
    }

    // Limpa o Loading da tela para renderizar o layout estruturado
    panesContainer.innerHTML = "";
    var paneClone = paneTemplate.content.cloneNode(true);
    var productsWrapper = paneClone.querySelector(".swiper-wrapper");
    productList.forEach(function (product) {
      var cardClone = productCardTemplate.content.cloneNode(true);
      var link = cardClone.querySelector(".super-menu__product-link");
      link.href = product.link || "#";
      cardClone.querySelector(".super-menu__product-image").src = product.image;
      cardClone.querySelector(".super-menu__product-image").alt = product.name;
      var titleEl = cardClone.querySelector(".super-menu__product-title");
      titleEl.parentNode.insertBefore(createRatingElement(product.rating), titleEl);
      titleEl.textContent = product.name;

      // Cria container para preços
      var priceContainer = document.createElement("div");
      priceContainer.className = "super-menu__product-prices";

      // 1. Preço Original (Vem primeiro)
      var priceSpan = document.createElement("span");
      priceSpan.className = "super-menu__product-price";
      if (product.price_discount) {
        priceSpan.classList.add("super-menu__product-price--has-discount");
      }
      priceSpan.textContent = product.price;
      priceContainer.appendChild(priceSpan);

      // 3. Novas Parcelas (Exibidas como: {quantidade}x de {valor})
      if (product.no_interest_installments && Number(product.no_interest_installments) > 1) {
        var installmentSpan = document.createElement("span");
        installmentSpan.className = "super-menu__product-installment-price";
        installmentSpan.textContent = "".concat(product.no_interest_installments, "x de ").concat(product.price_simulator_no_interest);
        priceContainer.appendChild(installmentSpan);
      }

      // 2. Preço com Desconto (Vem depois)
      if (product.price_discount) {
        var discountSpan = document.createElement("span");
        discountSpan.className = "super-menu__product-price-discount";
        discountSpan.textContent = "".concat(product.price_discount, " \xE0 vista no PIX");
        priceContainer.appendChild(discountSpan);
      }
      link.appendChild(priceContainer);
      productsWrapper.appendChild(cardClone);
    });

    // Insere o novo template limpo no DOM
    panesContainer.appendChild(paneClone);

    // Aplica o link correto diretamente no "See more" do painel que acabou de entrar
    updateSeeMoreLink(href);

    // Limpa a instância anterior do Swiper de produtos antes de recriar
    if (productsSwiperInstance) productsSwiperInstance.destroy(true, true);

    // Inicializa o Swiper de produtos usando a sua função genérica
    var productsContainer = panesContainer.querySelector(".super-menu__products-swiper");
    if (productsContainer) {
      productsSwiperInstance = (0, _swiper.initSwiper)(productsContainer);
    }
  }
  function renderSuperMenuInfoPane(data) {
    var panesContainer = superMenu.querySelector(".super-menu__panes");
    if (!panesContainer) return;
    var template = document.getElementById("super-menu-info-pane-template");
    if (!template) return;
    panesContainer.innerHTML = "";
    var clone = template.content.cloneNode(true);
    var imageEl = clone.querySelector(".super-menu__info-pane-image img");
    var titleEl = clone.querySelector(".super-menu__info-pane-title");
    var paragraphEl = clone.querySelector(".super-menu__info-pane-paragraph");
    var linkEl = clone.querySelector(".super-menu__info-pane-link");
    if (imageEl) {
      imageEl.src = data.image || "";
      imageEl.alt = data.title || "";
    }
    if (titleEl) titleEl.textContent = data.title || "";
    if (paragraphEl) paragraphEl.innerHTML = data.paragraph || "";
    if (linkEl) {
      if (data.link) {
        linkEl.href = data.link;
        var span = linkEl.querySelector("span");
        if (span) span.textContent = data.linkText || "";
        linkEl.style.display = "";
      } else {
        linkEl.style.display = "none";
      }
    }
    panesContainer.appendChild(clone);

    // esse tipo de painel não usa o "Veja mais" genérico de produtos
    updateSeeMoreLink(null);
  }
  function renderSuperMenuMobileInfoPane(container, data) {
    if (!container) return;
    var template = document.getElementById("super-menu-info-pane-template");
    if (!template) return;
    container.innerHTML = "";
    var clone = template.content.cloneNode(true);
    var imageEl = clone.querySelector(".super-menu__info-pane-image img");
    var titleEl = clone.querySelector(".super-menu__info-pane-title");
    var paragraphEl = clone.querySelector(".super-menu__info-pane-paragraph");
    var linkEl = clone.querySelector(".super-menu__info-pane-link");
    if (imageEl) {
      imageEl.src = data.image || "";
      imageEl.alt = data.title || "";
    }
    if (titleEl) titleEl.textContent = data.title || "";
    if (paragraphEl) paragraphEl.innerHTML = data.paragraph || "";
    if (linkEl) {
      if (data.link) {
        linkEl.href = data.link;
        var span = linkEl.querySelector("span");
        if (span) span.textContent = data.linkText || "";
        linkEl.style.display = "";
      } else {
        linkEl.style.display = "none";
      }
    }
    container.appendChild(clone);
  }
  function activateFirstTab(_x5) {
    return _activateFirstTab.apply(this, arguments);
  } // ----------------------------------------------------------------------------
  // DESKTOP — INPUT DE BUSCA
  // ----------------------------------------------------------------------------
  function _activateFirstTab() {
    _activateFirstTab = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(flow) {
      var firstTab;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            firstTab = superMenu.querySelector(".super-menu__tab-trigger");
            if (firstTab) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            superMenu.querySelectorAll(".super-menu__tab-trigger").forEach(function (tab) {
              return tab.classList.remove("active");
            });
            firstTab.classList.add("active");
            if (flow === "category") {
              categoryFlow(firstTab);
            }
            if (flow === "suggestion_search") {
              suggestionSearchFlow(firstTab);
            }
          case 2:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return _activateFirstTab.apply(this, arguments);
  }
  var headerSearchForm = document.querySelector(".header__content--search .header__search-form");
  var headerSearchInput = headerSearchForm === null || headerSearchForm === void 0 ? void 0 : headerSearchForm.querySelector(".header__search-input");
  var headerSearchClearButton = headerSearchForm === null || headerSearchForm === void 0 ? void 0 : headerSearchForm.querySelector(".header__search-clear");
  if (headerSearchForm && headerSearchInput) {
    headerSearchInput.addEventListener("input", function (event) {
      var query = event.target.value;
      console.log(query);
      var trimmedQuery = query.trim();
      if (inputSearchDebounceTimer) {
        window.clearTimeout(inputSearchDebounceTimer);
      }
      if (!trimmedQuery || trimmedQuery.length <= 3) {
        resetSearchToSuggestions();
        return;
      }
      inputSearchDebounceTimer = window.setTimeout(function () {
        inputSearchFlow(trimmedQuery);
      }, 1500);
    });
    if (headerSearchClearButton) {
      headerSearchClearButton.addEventListener("click", function () {
        headerSearchInput.value = "";
        if (inputSearchDebounceTimer) {
          window.clearTimeout(inputSearchDebounceTimer);
        }
        resetSearchToSuggestions();
        headerSearchInput.focus();
      });
    }
    headerSearchForm.addEventListener("submit", function (event) {
      event.preventDefault();
      var query = headerSearchInput.value.trim();
      if (!query) return;
      var href = "/busca?search=".concat(encodeURIComponent(query));
      window.location.href = href;
    });
  }
  function updateSeeMoreLink(url) {
    var seeMoreBtn = superMenu.querySelector(".super-menu__see-more");
    if (!seeMoreBtn) return;
    if (url) {
      seeMoreBtn.setAttribute("href", url);
      seeMoreBtn.style.display = "inline-flex";
    } else {
      seeMoreBtn.removeAttribute("href");
      seeMoreBtn.style.display = "none";
    }
  }
  function fetchProductsByCategory(_x6) {
    return _fetchProductsByCategory.apply(this, arguments);
  }
  function _fetchProductsByCategory() {
    _fetchProductsByCategory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(id) {
      var cleanCategoryId, url, response, data, _t;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            cleanCategoryId = String(id).replace(/\D/g, "");
            if (!productCache[cleanCategoryId]) {
              _context6.n = 1;
              break;
            }
            return _context6.a(2, productCache[cleanCategoryId]);
          case 1:
            url = "/index.php?route=product/category_new/getListByCategory&category_id=".concat(cleanCategoryId, "&limit=10");
            _context6.p = 2;
            _context6.n = 3;
            return fetch(url);
          case 3:
            response = _context6.v;
            if (response.ok) {
              _context6.n = 4;
              break;
            }
            throw new Error("Erro na requisi\xE7\xE3o. Status: ".concat(response.status));
          case 4:
            _context6.n = 5;
            return response.json();
          case 5:
            data = _context6.v;
            productCache[cleanCategoryId] = data;
            return _context6.a(2, data);
          case 6:
            _context6.p = 6;
            _t = _context6.v;
            console.error("Falha ao buscar produtos da categoria:", _t);
            return _context6.a(2, []);
        }
      }, _callee6, null, [[2, 6]]);
    }));
    return _fetchProductsByCategory.apply(this, arguments);
  }
  function fetchSuggestionSearch() {
    return _fetchSuggestionSearch.apply(this, arguments);
  }
  function _fetchSuggestionSearch() {
    _fetchSuggestionSearch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var url, response, json, suggestionsFromApi, normalized, _t2;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            if (!productCache.suggestion) {
              _context7.n = 1;
              break;
            }
            return _context7.a(2, productCache.suggestion);
          case 1:
            url = "/index.php?route=product/search_new/getRecentProducts";
            _context7.p = 2;
            _context7.n = 3;
            return fetch(url, {
              method: "GET",
              credentials: "same-origin",
              headers: {
                Accept: "application/json"
              }
            });
          case 3:
            response = _context7.v;
            if (response.ok) {
              _context7.n = 4;
              break;
            }
            throw new Error("Erro na requisi\xE7\xE3o. Status: ".concat(response.status));
          case 4:
            _context7.n = 5;
            return response.json();
          case 5:
            json = _context7.v;
            suggestionsFromApi = Array.isArray(json.products) ? json.products : [];
            normalized = suggestionsFromApi.map(function (item, index) {
              return normalizeSuggestionSearch(item, index);
            });
            productCache.suggestion = normalized;
            return _context7.a(2, normalized);
          case 6:
            _context7.p = 6;
            _t2 = _context7.v;
            console.error("Falha ao buscar produtos recentes:", _t2);
            return _context7.a(2, []);
        }
      }, _callee7, null, [[2, 6]]);
    }));
    return _fetchSuggestionSearch.apply(this, arguments);
  }
  function fetchProductsSearch(_x7) {
    return _fetchProductsSearch.apply(this, arguments);
  }
  function _fetchProductsSearch() {
    _fetchProductsSearch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(query) {
      var cacheKey, url, response, json, productsFromApi, combosFromApi, normalized, _t3;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            cacheKey = "search_".concat(String(query));
            if (!productCache[cacheKey]) {
              _context8.n = 1;
              break;
            }
            return _context8.a(2, productCache[cacheKey]);
          case 1:
            url = "/index.php?route=common/autocomplete/index_new&q=".concat(encodeURIComponent(query));
            _context8.p = 2;
            _context8.n = 3;
            return fetch(url, {
              method: "GET",
              credentials: "same-origin",
              headers: {
                Accept: "application/json"
              }
            });
          case 3:
            response = _context8.v;
            if (response.ok) {
              _context8.n = 4;
              break;
            }
            throw new Error("Erro na requisi\xE7\xE3o de autocomplete. Status: ".concat(response.status));
          case 4:
            _context8.n = 5;
            return response.json();
          case 5:
            json = _context8.v;
            productsFromApi = Array.isArray(json.products) ? json.products : [];
            combosFromApi = Array.isArray(json.combos) ? json.combos : [];
            normalized = [].concat(_toConsumableArray(productsFromApi.map(function (item, index) {
              return normalizeProductSearch(item, index);
            })), _toConsumableArray(combosFromApi.map(function (item, index) {
              return normalizeProductSearch(item, productsFromApi.length + index);
            })));
            productCache[cacheKey] = normalized;
            return _context8.a(2, normalized);
          case 6:
            _context8.p = 6;
            _t3 = _context8.v;
            console.error("Falha ao buscar produtos de autocomplete:", _t3);
            return _context8.a(2, []);
        }
      }, _callee8, null, [[2, 6]]);
    }));
    return _fetchProductsSearch.apply(this, arguments);
  }
  function normalizeSuggestionSearch(item, index) {
    return {
      id: "suggestion-".concat(index),
      name: item.name || "Produto",
      image: item.image || "",
      link: item.url || "#",
      price: (0, _number_formatter.numberFormatToCurrency)(item.price) || "",
      rating: item.rating || null
    };
  }
  function normalizeProductSearch(item, index) {
    return {
      id: "search-product-".concat(index),
      name: item.name || "Produto",
      image: item.image || "",
      link: item.url || "#",
      price: item.price || "",
      price_discount: item.price_discount || null,
      no_interest_installments: item.no_interest_installments || null,
      price_simulator_no_interest: item.price_simulator_no_interest || "",
      rating: item.rating || null
    };
  }

  // ----------------------------------------------------------------------------
  // MOBILE — RENDER GENÉRICO (usado tanto pelo menu de categorias quanto de busca)
  // ----------------------------------------------------------------------------

  function showLoadingMobileProductsState(container) {
    if (!container) return;
    container.innerHTML = "\n    <div class=\"super-menu__loading\" style=\"display: flex; justify-content: center; align-items: center; width: 100%; min-height: 200px; color: #666; font-weight: 500;\">\n      Carregando produtos...\n    </div>\n  ";
  }

  /**
   * Renderiza os cards de produto no painel de conteúdo mobile (categorias ou busca).
   * Inclui título com o nome da categoria/termo e link "veja mais" ao final, quando houver href.
   */
  function renderSuperMenuMobileProducts(container, products, categoryName, categoryHref) {
    var subtitle = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    if (!container) return;
    var productList = Array.isArray(products) ? products : [];
    var productCardTemplate = document.getElementById("super-menu-mobile-product-card-template");
    if (!productCardTemplate) return;
    container.innerHTML = "";

    // Título com o nome da categoria/termo pesquisado
    if (categoryName) {
      // 1. Cria a div wrapper (.super-menu__mobile-content-title)
      var titleWrapper = document.createElement("div");
      titleWrapper.className = "super-menu__mobile-content-title";

      // 2. Cria o h4 agora como .super-menu__mobile-content-main-title
      var title = document.createElement("h4");
      title.className = "super-menu__mobile-content-main-title";
      title.textContent = categoryName;
      titleWrapper.appendChild(title);

      // 3. Se houver subtítulo, cria e adiciona dentro da mesma div wrapper
      if (subtitle) {
        var subtitleEl = document.createElement("span");
        subtitleEl.className = "super-menu__mobile-content-subtitle";
        subtitleEl.textContent = subtitle;
        titleWrapper.appendChild(subtitleEl);
      }

      // 4. Insere a div wrapper completa dentro do container
      container.appendChild(titleWrapper);
    }
    if (!productList.length) {
      var empty = document.createElement("div");
      empty.className = "super-menu__empty";
      empty.style.cssText = "display: flex; justify-content: center; align-items: center; width: 100%; min-height: 200px; color: #666; font-weight: 500;";
      empty.textContent = "Nenhum produto encontrado.";
      container.appendChild(empty);
      return;
    }
    var fragment = document.createDocumentFragment();
    productList.forEach(function (product) {
      var cardClone = productCardTemplate.content.cloneNode(true);
      var link = cardClone.querySelector(".super-menu__product-link");
      var image = cardClone.querySelector(".super-menu__product-image");
      var title = cardClone.querySelector(".super-menu__product-title");
      link.href = product.link || "#";
      image.src = product.image || "";
      image.alt = product.name || "";
      title.parentNode.insertBefore(createRatingElement(product.rating), title);
      title.textContent = product.name || "";
      var priceContainer = document.createElement("div");
      priceContainer.className = "super-menu__product-prices";
      var priceSpan = document.createElement("span");
      priceSpan.className = "super-menu__product-price";
      if (product.price_discount) {
        priceSpan.classList.add("super-menu__product-price--has-discount");
      }
      priceSpan.textContent = product.price || "";
      priceContainer.appendChild(priceSpan);
      if (product.no_interest_installments && Number(product.no_interest_installments) > 1) {
        var installmentSpan = document.createElement("span");
        installmentSpan.className = "super-menu__product-installment-price";
        installmentSpan.textContent = "".concat(product.no_interest_installments, "x de ").concat(product.price_simulator_no_interest);
        priceContainer.appendChild(installmentSpan);
      }
      if (product.price_discount) {
        var discountSpan = document.createElement("span");
        discountSpan.className = "super-menu__product-price-discount";
        discountSpan.textContent = "".concat(product.price_discount, " \xE0 vista no PIX");
        priceContainer.appendChild(discountSpan);
      }
      link.appendChild(priceContainer);
      fragment.appendChild(cardClone);
    });
    container.appendChild(fragment);

    // Link "veja mais" ao final da lista
    if (categoryHref) {
      var seeMore = document.createElement("a");
      seeMore.className = "super-menu__mobile-see-more";
      seeMore.href = categoryHref;
      seeMore.innerHTML = "\n    <span>Veja mais</span>\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"5\" height=\"7\" viewBox=\"0 0 5 7\" fill=\"none\">\n      <path d=\"M0.198 6.858C0.09 6.858 0.036 6.786 0.036 6.642C0.036 6.618 0.042 6.594 0.054 6.57C0.066 6.534 0.078 6.504 0.09 6.48C0.426 5.964 0.75 5.526 1.062 5.166C1.386 4.806 1.692 4.5 1.98 4.248C2.28 3.984 2.562 3.75 2.826 3.546C2.898 3.486 2.934 3.444 2.934 3.42C2.934 3.384 2.898 3.342 2.826 3.294C2.562 3.09 2.28 2.868 1.98 2.628C1.692 2.376 1.386 2.076 1.062 1.728C0.75 1.368 0.426 0.935999 0.09 0.431999C0.066 0.383999 0.042 0.342 0.018 0.306C0.00599998 0.258 0 0.21 0 0.162C0 0.054 0.036 0 0.108 0C0.216 0 0.318 0.0419995 0.414 0.125999C0.51 0.209999 0.582 0.276 0.63 0.323999C0.942 0.623999 1.242 0.894 1.53 1.134C1.83 1.374 2.136 1.608 2.448 1.836C2.76 2.052 3.096 2.28 3.456 2.52C3.828 2.748 4.242 3 4.698 3.276C4.734 3.288 4.752 3.33 4.752 3.402C4.752 3.486 4.722 3.582 4.662 3.69C4.602 3.798 4.524 3.876 4.428 3.924C4.164 4.044 3.882 4.194 3.582 4.374C3.282 4.542 2.97 4.74 2.646 4.968C2.334 5.184 2.016 5.424 1.692 5.688C1.368 5.952 1.05 6.234 0.738 6.534C0.69 6.582 0.618 6.648 0.522 6.732C0.426 6.816 0.318 6.858 0.198 6.858Z\" fill=\"currentColor\"/>\n    </svg>\n  ";
      container.appendChild(seeMore);
    }
  }

  /**
   * Retorna o container de conteúdo (.super-menu__mobile-content) correspondente
   * ao wrapper (.super-menu__mobile) onde o trigger foi clicado.
   */
  function resolveMobileContentContainer(trigger) {
    var wrapper = trigger.closest(".super-menu__mobile");
    return (wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".super-menu__mobile-content")) || null;
  }

  /**
   * FLUXO: Ao clicar em um trigger dentro de qualquer menu mobile
   * (categorias ou busca). Decide qual fetch usar com base nos data-attributes.
   */
  function mobileResultFlow(_x8) {
    return _mobileResultFlow.apply(this, arguments);
  }
  function _mobileResultFlow() {
    _mobileResultFlow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(trigger) {
      var container, categoryName, suggestionId, searchTerm, categoryId, products, href, categoryHref;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            if (!isMobileProductsLoading) {
              _context9.n = 1;
              break;
            }
            return _context9.a(2);
          case 1:
            container = resolveMobileContentContainer(trigger);
            if (container) {
              _context9.n = 2;
              break;
            }
            return _context9.a(2);
          case 2:
            categoryName = getTriggerCategoryName(trigger);
            suggestionId = trigger.dataset.id;
            searchTerm = trigger.dataset.search;
            categoryId = trigger.dataset.categoryId;
            if (!(!suggestionId && !searchTerm && !categoryId)) {
              _context9.n = 3;
              break;
            }
            return _context9.a(2);
          case 3:
            if (!(categoryId && superMenuInfoData[categoryId])) {
              _context9.n = 4;
              break;
            }
            renderSuperMenuMobileInfoPane(container, superMenuInfoData[categoryId]);
            return _context9.a(2);
          case 4:
            isMobileProductsLoading = true;
            setMobileTriggersLocked(true);
            _context9.p = 5;
            showLoadingMobileProductsState(container);
            products = [];
            href = null;
            if (!(suggestionId === "suggestion-search")) {
              _context9.n = 7;
              break;
            }
            _context9.n = 6;
            return fetchSuggestionSearch();
          case 6:
            products = _context9.v;
            href = null;
            _context9.n = 11;
            break;
          case 7:
            if (!searchTerm) {
              _context9.n = 9;
              break;
            }
            _context9.n = 8;
            return fetchProductsSearch(searchTerm);
          case 8:
            products = _context9.v;
            href = "/busca?search=".concat(encodeURIComponent(searchTerm));
            _context9.n = 11;
            break;
          case 9:
            if (!categoryId) {
              _context9.n = 11;
              break;
            }
            categoryHref = trigger.dataset.href;
            _context9.n = 10;
            return fetchProductsByCategory(categoryId);
          case 10:
            products = _context9.v;
            href = categoryHref || null;
          case 11:
            renderSuperMenuMobileProducts(container, products, categoryName, href);
          case 12:
            _context9.p = 12;
            isMobileProductsLoading = false;
            setMobileTriggersLocked(false);
            return _context9.f(12);
          case 13:
            return _context9.a(2);
        }
      }, _callee9, null, [[5,, 12, 13]]);
    }));
    return _mobileResultFlow.apply(this, arguments);
  }
  function getTriggerCategoryName(trigger) {
    var _trigger$querySelecto;
    return ((_trigger$querySelecto = trigger.querySelector("span")) === null || _trigger$querySelecto === void 0 ? void 0 : _trigger$querySelecto.textContent.trim()) || trigger.textContent.trim();
  }
  function setMobileTriggersLocked(locked) {
    var triggers = document.querySelectorAll(".super-menu__mobile-result-trigger");
    triggers.forEach(function (trigger) {
      trigger.disabled = locked;
      trigger.classList.toggle("is-disabled", locked);
    });
  }
  function resetAllMobileTriggersState(rootEl) {
    if (!rootEl) return;
    rootEl.querySelectorAll(".super-menu__mobile-result-trigger, .super-menu__mobile-item-button, .super-menu__mobile-info-item-button").forEach(function (btn) {
      return btn.classList.remove("active");
    });
  }
  function activateMobileTrigger(trigger) {
    var wrapper = trigger.closest(".super-menu__mobile") || trigger.closest(".super-menu__mobile-list");
    if (wrapper) {
      resetAllMobileTriggersState(wrapper);
    }
    trigger.classList.add("active");
  }
  window.activateMobileTrigger = activateMobileTrigger;
  var mobileInfoData = {};
  function setMobileInfoData(data) {
    mobileInfoData = data || {};
  }
  window.setMobileInfoData = setMobileInfoData;
  function bindMobileResultTriggers(rootEl) {
    if (!rootEl) return;
    rootEl.addEventListener("click", function (e) {
      var trigger = e.target.closest(".super-menu__mobile-result-trigger");
      if (!trigger || trigger.disabled) return;
      if (trigger.tagName === "A") return;
      e.preventDefault();

      // 1. SUB-ITEM: nunca mexe no accordion do item pai.
      var subList = trigger.closest(".super-menu__mobile-sub-list");
      if (subList) {
        subList.querySelectorAll(".super-menu__mobile-result-trigger").forEach(function (btn) {
          return btn.classList.remove("active");
        });
        trigger.classList.add("active");
        trigger.setAttribute("aria-expanded", "true");
        if (typeof mobileResultFlow === "function") {
          mobileResultFlow(trigger);
        }
        return;
      }

      // 2. ITEM PRINCIPAL (categoria no nível raiz)
      var itemContainer = trigger.closest(".super-menu__mobile-item");
      var hasSubmenu = itemContainer === null || itemContainer === void 0 ? void 0 : itemContainer.querySelector(":scope > .super-menu__mobile-sub-list, :scope > ul");
      if (hasSubmenu) {
        var isCurrentlyOpen = itemContainer.hasAttribute("open");
        rootEl.querySelectorAll(".super-menu__mobile-item").forEach(function (li) {
          li.removeAttribute("open");
          var mainBtn = li.querySelector(":scope > .super-menu__mobile-item-button");
          if (mainBtn) {
            mainBtn.setAttribute("aria-expanded", "false");
            mainBtn.classList.remove("active");
          }
        });
        if (!isCurrentlyOpen) {
          itemContainer.setAttribute("open", "");
          trigger.setAttribute("aria-expanded", "true");
          trigger.classList.add("active");
        }
      } else {
        activateMobileTrigger(trigger);
      }
      if (typeof mobileResultFlow === "function") {
        mobileResultFlow(trigger);
      }
    });
  }
  bindMobileResultTriggers(superMenuMobile);
  bindMobileResultTriggers(superMenuSearchMobile);

  // ----------------------------------------------------------------------------
  // MOBILE — INPUT DE BUSCA
  // ----------------------------------------------------------------------------
  function mobileInputSearchFlow(_x9) {
    return _mobileInputSearchFlow.apply(this, arguments);
  }
  function _mobileInputSearchFlow() {
    _mobileInputSearchFlow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(query) {
      var trimmedQuery, href, products, hasResult;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            if (superMenuSearchMobileContent) {
              _context0.n = 1;
              break;
            }
            return _context0.a(2);
          case 1:
            if (!isMobileProductsLoading) {
              _context0.n = 2;
              break;
            }
            return _context0.a(2);
          case 2:
            trimmedQuery = query.trim();
            if (trimmedQuery) {
              _context0.n = 3;
              break;
            }
            loadFirstMobileSearchSuggestion();
            return _context0.a(2);
          case 3:
            isMobileProductsLoading = true;
            setMobileTriggersLocked(true);
            _context0.p = 4;
            // Nenhum trigger fica "ativo" durante a digitação livre
            superMenuSearchMobile === null || superMenuSearchMobile === void 0 || superMenuSearchMobile.querySelectorAll(".super-menu__mobile-result-trigger").forEach(function (btn) {
              return btn.classList.remove("active");
            });
            showLoadingMobileProductsState(superMenuSearchMobileContent);
            href = "/busca?search=".concat(encodeURIComponent(trimmedQuery));
            _context0.n = 5;
            return fetchProductsSearch(trimmedQuery);
          case 5:
            products = _context0.v;
            hasResult = true; // Sem resultado na busca: cai para a lista de sugestões (fetchSuggestionSearch)
            if (products.length) {
              _context0.n = 7;
              break;
            }
            hasResult = false;
            _context0.n = 6;
            return fetchSuggestionSearch();
          case 6:
            products = _context0.v;
          case 7:
            renderSuperMenuMobileProducts(superMenuSearchMobileContent, products, hasResult ? "Resultados" : "Não encontramos sua pesquisa.", hasResult ? href : null, hasResult ? null : "Mas você pode gostar de");
          case 8:
            _context0.p = 8;
            isMobileProductsLoading = false;
            setMobileTriggersLocked(false);
            return _context0.f(8);
          case 9:
            return _context0.a(2);
        }
      }, _callee0, null, [[4,, 8, 9]]);
    }));
    return _mobileInputSearchFlow.apply(this, arguments);
  }
  if (superMenuSearchMobileInput) {
    superMenuSearchMobileInput.addEventListener("input", function (event) {
      var query = event.target.value;
      var trimmedQuery = query.trim();
      if (mobileInputSearchDebounceTimer) {
        window.clearTimeout(mobileInputSearchDebounceTimer);
      }
      if (!trimmedQuery || trimmedQuery.length <= 3) {
        loadFirstMobileSearchSuggestion();
        return;
      }
      mobileInputSearchDebounceTimer = window.setTimeout(function () {
        mobileInputSearchFlow(trimmedQuery);
      }, 1500);
    });
  }
  var searchMobileForm = superMenuSearchMobile === null || superMenuSearchMobile === void 0 ? void 0 : superMenuSearchMobile.querySelector(".header__search-form");
  var searchMobileClearButton = searchMobileForm === null || searchMobileForm === void 0 ? void 0 : searchMobileForm.querySelector(".header__search-clear");
  if (searchMobileForm && superMenuSearchMobileInput) {
    searchMobileForm.addEventListener("submit", function (event) {
      event.preventDefault();
      var query = superMenuSearchMobileInput.value.trim();
      if (!query) return;
      var href = "/busca?search=".concat(encodeURIComponent(query));
      window.location.href = href;
    });
    if (searchMobileClearButton) {
      searchMobileClearButton.addEventListener("click", function () {
        superMenuSearchMobileInput.value = "";
        if (mobileInputSearchDebounceTimer) {
          window.clearTimeout(mobileInputSearchDebounceTimer);
        }
        loadFirstMobileSearchSuggestion();
        superMenuSearchMobileInput.focus();
      });
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.initSwiper = initSwiper;
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  // ============================================================================
  // 1. FUNÇÃO GENÉRICA PARA INICIALIZAR SWIPERS
  // ============================================================================
  /**
   * Inicializa um swiper usando configurações do data-swiper-config
   * @param {HTMLElement} element - elemento DOM do swiper
   * @param {Object} defaultOptions - Opções padrão a mesclar com as do data-swiper-config
   * @returns {Swiper} Instância do swiper criada
   */
  function initSwiper(element) {
    var defaultOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!element || !element.classList.contains("swiper")) {
      console.warn("Elemento swiper não encontrado ou inválido:", element);
      return null;
    }

    // Lê o data-swiper-config
    var configAttr = element.getAttribute("data-swiper-config");
    var htmlConfig = configAttr ? JSON.parse(configAttr) : {};

    // Mescla configurações: padrão > usuário > observer
    var finalConfig = _objectSpread(_objectSpread({
      observer: true,
      observeParents: true
    }, defaultOptions), htmlConfig);
    var swiper = new Swiper(element, finalConfig);
    return swiper;
  }
});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.closeAll = closeAll;
  _exports.closeDrawer = closeDrawer;
  _exports.openDrawer = openDrawer;
  var overlays = document.querySelectorAll(".drawer-overlay, .super-menu-overlay");
  var header = document.querySelector(".header");

  // Mapeia qual botão abriu cada drawer, já que múltiplos botões
  // podem abrir o mesmo id de drawer (ex: várias .header__nav-button abrindo "super-menu").
  var activeDrawerButtons = {};
  function handleOverlays(state) {
    var drawerType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    overlays.forEach(function (overlay) {
      if (state === "closed") {
        overlay.dataset.state = "closed";
        overlay.setAttribute("aria-hidden", "true");
      } else if (drawerType) {
        var isSuperMenuOverlay = overlay.classList.contains("super-menu-overlay");
        var isDrawerOverlay = overlay.classList.contains("drawer-overlay");
        if (drawerType === "super-menu" && isSuperMenuOverlay) {
          overlay.dataset.state = "open";
          overlay.setAttribute("aria-hidden", "false");
        } else if (drawerType === "drawer" && isDrawerOverlay) {
          overlay.dataset.state = "open";
          overlay.setAttribute("aria-hidden", "false");
        } else {
          overlay.dataset.state = "closed";
          overlay.setAttribute("aria-hidden", "true");
        }
      }
    });
  }
  function setButtonActive(button, isActive) {
    if (!button) return;
    button.classList.toggle("active", isActive);
    button.setAttribute("aria-expanded", isActive ? "true" : "false");
  }

  /**
   * @param {string} drawer_id
   * @param {HTMLElement|null} triggerButton - Passe o botão explicitamente
   *   quando ele não tiver [data-drawer-target] (ex: triggers do super menu).
   */
  function openDrawer(drawer_id) {
    var triggerButton = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    closeAll();
    var drawer = document.getElementById(drawer_id);
    if (!drawer) return;
    var button = triggerButton || document.querySelector("[data-drawer-target=\"".concat(drawer_id, "\"]"));
    var drawerType = drawer.getAttribute("data-drawer");
    drawer.dataset.state = "open";
    drawer.setAttribute("aria-hidden", "false");
    handleOverlays("open", drawerType);
    if (header) {
      header.dataset.state = "open";
    }
    if (button) {
      setButtonActive(button, true);
      activeDrawerButtons[drawer_id] = button;
    }
  }
  function closeAll() {
    document.querySelectorAll('[data-drawer][data-state="open"]').forEach(function (drawer) {
      drawer.dataset.state = "closed";
      drawer.setAttribute("aria-hidden", "true");
      var drawer_id = drawer.id;
      var button = activeDrawerButtons[drawer_id] || document.querySelector("[data-drawer-target=\"".concat(drawer_id, "\"]"));
      setButtonActive(button, false);
      delete activeDrawerButtons[drawer_id];
    });
    handleOverlays("closed");
    if (header) {
      header.dataset.state = "closed";
    }
  }
  function closeDrawer(drawer_id) {
    var drawer = document.getElementById(drawer_id);
    if (drawer) {
      drawer.dataset.state = "closed";
      drawer.setAttribute("aria-hidden", "true");
      var button = activeDrawerButtons[drawer_id] || document.querySelector("[data-drawer-target=\"".concat(drawer_id, "\"]"));
      setButtonActive(button, false);
      delete activeDrawerButtons[drawer_id];
    }
    var anyOpen = document.querySelector('[data-drawer][data-state="open"]');
    if (!anyOpen) {
      handleOverlays("closed");
      if (header) {
        header.dataset.state = "closed";
      }
    } else {
      var remainingDrawerType = anyOpen.getAttribute("data-drawer");
      handleOverlays("open", remainingDrawerType);
    }
  }
});

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.currencyFormatToNumber = currencyFormatToNumber;
  _exports.numberFormatToCurrency = numberFormatToCurrency;
  _exports.numberFormatToString = numberFormatToString;
  _exports.stringFormatToNumber = stringFormatToNumber;
  /**
   * [numberFormatToCurrency] Formatação de numero para moeda
   * @author Eduardo Xavier     <[<eduardo.xavier@irroba.com.br>]>
   * @param  [number] valor       [Numero a ser formatado]
   * @param  [string] moeda       [Moeda a ser utilizada] [BRL, USD, EUR, etc]
   * @param  [string] locale      [Localidade da formatação da casa decimal a ser utilizada] [pt-BR, en-US, etc]
   * @return [string]             [Retorna um valor formatado para moeda] [R$ 1.234,56, $1,234.56, etc]
   */
  function numberFormatToCurrency(valor) {
    var moeda = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "BRL";
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "pt-BR";
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: moeda
    }).format(valor);
  }

  /**
   * [currencyFormatToNumber] Formatação de moeda para numero
   * @author Eduardo Xavier     <[<eduardo.xavier@irroba.com.br>]>
   * @param  [string] valorMoeda  [Valor em moeda a ser formatado em numero] [R$ 1.234,56, $1,234.56, etc]
   * @param  [string] locale      [Localidade da formatação da casa decimal a ser utilizada] [pt-BR, en-US, etc]
   * @return [number]             [Retorna o valor formatado em numero] [1234,56, 1234.56, etc]
   */
  function currencyFormatToNumber(valorMoeda) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "pt-BR";
    var exemplo = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: "BRL"
    }).format(1234567.89);

    // Detecta os separadores com base no valor formatado
    var match = exemplo.match(/([\d])([^0-9\s])([\d]{3})[^0-9]*([\d]{2})/);
    if (!match) {
      console.warn("Não foi possível detectar os separadores corretamente.");
      return NaN;
    }
    var separadorMilhar = match[2];
    var separadorDecimal = exemplo.match(/(\d+)(\D)(\d{2})\D*$/)[2];

    // Limpa e converte
    var numeroLimpo = valorMoeda.replace(/[^\d.,-]/g, "") // Remove símbolos de moeda e espaços
    .replace(new RegExp("\\".concat(separadorMilhar), "g"), "") // Remove milhar
    .replace(separadorDecimal, "."); // Substitui decimal por ponto

    return parseFloat(numeroLimpo);
  }

  /**
   * [numberFormatToString] Formatação de numero para string
   * @author Eduardo Xavier     <[<eduardo.xavier@irroba.com.br>]>
   * @param  [number] valor       [Numero a ser formatado] [1.234,56, 1234.56, etc]
   * @param  [string] locale      [Localidade da formatação da casa decimal a ser utilizada] [pt-BR, en-US, etc]
   * @return [string]             [Retorna o valor formatado em string] ['1.234,56', '1,234.56', etc]
   */
  function numberFormatToString(valor) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "pt-BR";
    var casasDecimais = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: casasDecimais,
      maximumFractionDigits: casasDecimais
    }).format(valor);
  }

  /**
   * [stringFormatToNumber] Formatação de string para numero
   * @author Eduardo Xavier       <[<eduardo.xavier@irroba.com.br>]>
   * @param  [string] numeroString [String a ser formatada] ['1.234,56', '1,234.56', etc]
   * @param  [string] locale      [Localidade da formatação da casa decimal a ser utilizada] [pt-BR, en-US, etc]
   * @return [number]             [Retorna o valor formatado em numero] [1234.56, 1.23456, etc]
   */
  function stringFormatToNumber(numeroString) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "pt-BR";
    // Usa um número que força o uso de separador de milhar E decimal
    var exemplo = new Intl.NumberFormat(locale).format(1234567.89);

    // Detecta separador decimal e milhar
    var match = exemplo.match(/1(.?)234(.?)567(.?)89/);
    if (!match) {
      console.warn("Separadores não detectados");
      return NaN;
    }
    var separadorMilhar = match[1];
    var separadorDecimal = match[3];

    // Limpa a string: remove milhar e troca decimal por ponto
    var numeroLimpo = numeroString.replace(new RegExp("\\".concat(separadorMilhar), 'g'), '').replace(separadorDecimal, '.').replace(/[^\d.-]/g, ''); // Remove qualquer símbolo inesperado

    return parseFloat(numeroLimpo);
  }
});

/***/ }),
/* 5 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
  "use strict";

  var filter = document.getElementById("content-filters-v2--top");
  var filterLeft = document.getElementById("content-filters-v2--left");
  var toolbar = document.querySelector(".toolbar-shop");
  var filterForm;
  var filterOverlay;
  if (filter && toolbar) {
    filterForm = filter.querySelector(".filterForm");
    if (filterForm) {
      renderFilter(filterForm, filter);
    }
  }
  if (filterLeft && toolbar) {
    filterForm = filterLeft.querySelector(".filterForm");
    if (filterForm) {
      filterForm.classList.remove("filterForm--side");
      renderFilter(filterForm, filterLeft);
    }
  }
  function renderFilter(filterForm, filter) {
    toolbar.prepend(filterForm);
    var filterClearButtons = filter.querySelector(".buttons");
    var filterContainers = filterForm.querySelectorAll(".filter-custom-container, .filter-price-container");
    filterContainers.forEach(function (container) {
      if (container.tagName.toLowerCase() === "details") return;
      if (container.classList.contains("filter-price-container")) {
        var priceInputs = container.querySelectorAll('input[type="radio"]');
        priceInputs.forEach(function (input) {
          input.classList.add("radio-input");
          var label = container.querySelector("label[for=\"".concat(input.id, "\"]"));
          if (label) {
            label.className = "filter-box filter-custom-option";
          }
        });
      }
      var details = document.createElement("details");
      details.className = container.className;

      // Define o atributo name para o comportamento nativo de fechar os outros ao abrir um
      details.name = "filter-accordion-group";
      Array.from(container.attributes).forEach(function (attr) {
        details.setAttribute(attr.name, attr.value);
      });
      var titleElement = container.querySelector(".filter-title");
      var summary = document.createElement("summary");
      summary.className = "filter-title";
      var titleText = titleElement ? titleElement.textContent.trim() : "Filtro";
      summary.innerHTML = "\n        <span>".concat(titleText, "</span>\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"7\" viewBox=\"0 0 10 7\" fill=\"none\">\n          <path d=\"M-1.27492e-08 0.291666C-5.79507e-09 0.132575 0.104986 0.0530299 0.31496 0.0530299C0.349956 0.0530299 0.384949 0.0618683 0.419945 0.0795451C0.472438 0.0972219 0.516183 0.114899 0.551179 0.132575C1.30359 0.627525 1.94226 1.1048 2.46719 1.56439C2.99213 2.04167 3.43832 2.49242 3.80577 2.91667C4.19072 3.35859 4.53193 3.77399 4.8294 4.16288C4.91688 4.26894 4.97813 4.32197 5.01312 4.32197C5.06562 4.32197 5.12686 4.26894 5.19685 4.16288C5.49431 3.77399 5.81802 3.35859 6.16798 2.91667C6.53543 2.49242 6.97288 2.04167 7.48031 1.56439C8.00525 1.1048 8.63517 0.627525 9.37008 0.132576C9.44007 0.0972222 9.50131 0.0618686 9.55381 0.0265151C9.6238 0.00883834 9.69379 -1.33849e-08 9.76378 -1.03255e-08C9.92126 -3.44184e-09 10 0.0530302 10 0.159091C10 0.318182 9.93876 0.468434 9.81627 0.609849C9.69379 0.751263 9.59755 0.857323 9.52756 0.928031C9.09011 1.38763 8.69641 1.82955 8.34646 2.25379C7.9965 2.69571 7.65529 3.14646 7.32283 3.60606C7.00787 4.06566 6.67542 4.56061 6.32546 5.09091C5.993 5.63889 5.62555 6.24874 5.2231 6.92046C5.2056 6.97349 5.14436 7 5.03937 7C4.91689 7 4.7769 6.95581 4.61942 6.86742C4.46194 6.77904 4.34821 6.66414 4.27821 6.52273C4.10324 6.13384 3.88451 5.71844 3.62205 5.27652C3.37708 4.8346 3.08836 4.375 2.7559 3.89773C2.44094 3.43813 2.09099 2.9697 1.70604 2.49242C1.32108 2.01515 0.909885 1.54672 0.47244 1.08712C0.402449 1.01641 0.30621 0.910353 0.183726 0.768939C0.0612411 0.627525 -2.04759e-08 0.468434 -1.27492e-08 0.291666Z\" fill=\"black\"/>\n        </svg>\n      ");
      details.appendChild(summary);
      if (titleElement) titleElement.remove();
      while (container.firstChild) {
        details.appendChild(container.firstChild);
      }

      // Listener para fechar os outros <details> ao abrir um novo (fallback JS)
      details.addEventListener("toggle", function () {
        var _this = this;
        if (this.open) {
          filterForm.querySelectorAll("details").forEach(function (otherDetails) {
            if (otherDetails !== _this) {
              otherDetails.open = false;
            }
          });
        }
      });
      container.parentNode.replaceChild(details, container);
    });
    var filterButton = filterForm.querySelector(".filter-button");
    if (filterButton) {
      filterButton.innerHTML = "\n        <span>Aplicar filtros</span>\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"5\" height=\"7\" viewBox=\"0 0 5 7\" fill=\"none\">\n          <path d=\"M0.198 6.858C0.09 6.858 0.036 6.786 0.036 6.642C0.036 6.618 0.042 6.594 0.054 6.57C0.066 6.534 0.078 6.504 0.09 6.48C0.426 5.964 0.75 5.526 1.062 5.166C1.386 4.806 1.692 4.5 1.98 4.248C2.28 3.984 2.562 3.75 2.826 3.546C2.898 3.486 2.934 3.444 2.934 3.42C2.934 3.384 2.898 3.342 2.826 3.294C2.562 3.09 2.28 2.868 1.98 2.628C1.692 2.376 1.386 2.076 1.062 1.728C0.75 1.368 0.426 0.935999 0.09 0.431999C0.066 0.383999 0.042 0.342 0.018 0.306C0.00599998 0.258 0 0.21 0 0.162C0 0.054 0.036 0 0.108 0C0.216 0 0.318 0.0419995 0.414 0.125999C0.51 0.209999 0.582 0.276 0.63 0.323999C0.942 0.623999 1.242 0.894 1.53 1.134C1.83 1.374 2.136 1.608 2.448 1.836C2.76 2.052 3.096 2.28 3.456 2.52C3.828 2.748 4.242 3 4.698 3.276C4.734 3.288 4.752 3.33 4.752 3.402C4.752 3.486 4.722 3.582 4.662 3.69C4.602 3.798 4.524 3.876 4.428 3.924C4.164 4.044 3.882 4.194 3.582 4.374C3.282 4.542 2.97 4.74 2.646 4.968C2.334 5.184 2.016 5.424 1.692 5.688C1.368 5.952 1.05 6.234 0.738 6.534C0.69 6.582 0.618 6.648 0.522 6.732C0.426 6.816 0.318 6.858 0.198 6.858Z\" fill=\"black\"/>\n        </svg>\n      ";
    }
    if (filterClearButtons) {
      filterForm.appendChild(filterClearButtons);
    }
    setupMobileFilterHeader(filterForm);
    setupMobileFilterOverlay(filterForm);
  }

  // ============================================================================
  // MOBILE — TRIGGER, HEADER E OVERLAY DO DRAWER DE FILTROS
  // ============================================================================

  function setupMobileFilterHeader(filterForm) {
    var topContainer = filterForm.querySelector(".filterActionContainer--top");
    if (!topContainer) return;
    topContainer.innerHTML = "\n    <div class=\"filter-mobile-header\">\n      <h3 class=\"filter-mobile-header__title\">Filtrar por</h3>\n      <button type=\"button\" class=\"filter-mobile-header__close js-close-filters\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\">\n          <path d=\"M7.00098 6.29395L13.2939 0.00195312L14.001 0.708984L7.70801 7.00098L14.001 13.293L13.2939 14L7.00098 7.70703L0.707031 14.002L0 13.2949L6.29395 7.00098L0 0.707031L0.707031 0L7.00098 6.29395Z\" fill=\"black\" fill-opacity=\"0.3\"/>\n        </svg>\n      </button>\n    </div>\n    <p class=\"filter-mobile-header__subtitle\">Selecione as op\xE7\xF5es abaixo para filtrar.</p>\n  ";
  }

  /**
   * Cria o overlay como IRMÃO do filterForm no DOM (não como filho),
   * inserido logo após ele.
   */
  function setupMobileFilterOverlay(filterForm) {
    if (filterOverlay) return; // evita duplicar caso renderFilter rode mais de uma vez

    filterOverlay = document.createElement("div");
    filterOverlay.className = "filter-overlay";
    filterForm.insertAdjacentElement("afterend", filterOverlay);
    filterOverlay.addEventListener("click", function () {
      return closeMobileFilters(filterForm);
    });
  }
  function openMobileFilters(filterForm) {
    var _filterOverlay;
    filterForm.dataset.state = "open";
    (_filterOverlay = filterOverlay) === null || _filterOverlay === void 0 || _filterOverlay.setAttribute("data-state", "open");
    document.body.style.overflow = "hidden";
  }
  function closeMobileFilters(filterForm) {
    var _filterOverlay2;
    filterForm.dataset.state = "closed";
    (_filterOverlay2 = filterOverlay) === null || _filterOverlay2 === void 0 || _filterOverlay2.setAttribute("data-state", "closed");
    document.body.style.overflow = "";
  }
  function insertMobileFilterTrigger() {
    if (!toolbar || !filterForm) return;
    if (toolbar.querySelector(".toolbar-shop-filter-trigger")) return;
    var trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "toolbar-shop-filter-trigger";
    trigger.innerHTML = "\n  <span>\n    Filtrar\n  </span>\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"7\" height=\"10\" viewBox=\"0 0 7 10\" fill=\"none\">\n    <path d=\"M0.291667 10C0.132576 10 0.0530303 9.89501 0.0530303 9.68504C0.0530303 9.65004 0.0618687 9.61505 0.0795455 9.58006C0.0972223 9.52756 0.114899 9.48382 0.132576 9.44882C0.627525 8.69641 1.1048 8.05774 1.56439 7.53281C2.04167 7.00787 2.49242 6.56168 2.91667 6.19423C3.35859 5.80928 3.77399 5.46807 4.16288 5.1706C4.26894 5.08312 4.32197 5.02187 4.32197 4.98688C4.32197 4.93438 4.26894 4.87314 4.16288 4.80315C3.77399 4.50569 3.35859 4.18198 2.91667 3.83202C2.49242 3.46457 2.04167 3.02712 1.56439 2.51969C1.1048 1.99475 0.627525 1.36483 0.132576 0.62992C0.0972222 0.559929 0.0618686 0.498687 0.0265152 0.446194C0.00883836 0.376203 0 0.306212 0 0.23622C0 0.0787402 0.0530302 0 0.159091 0C0.318182 0 0.468434 0.0612416 0.609849 0.183726C0.751263 0.306211 0.857323 0.402449 0.928031 0.47244C1.38763 0.909886 1.82955 1.30359 2.25379 1.65354C2.69571 2.0035 3.14646 2.34471 3.60606 2.67717C4.06566 2.99213 4.56061 3.32458 5.09091 3.67454C5.63889 4.007 6.24874 4.37445 6.92046 4.7769C6.97349 4.7944 7 4.85564 7 4.96063C7 5.08311 6.95581 5.2231 6.86742 5.38058C6.77904 5.53806 6.66414 5.65179 6.52273 5.72179C6.13384 5.89676 5.71844 6.11549 5.27652 6.37795C4.8346 6.62292 4.375 6.91164 3.89773 7.24409C3.43813 7.55906 2.9697 7.90901 2.49242 8.29396C2.01515 8.67892 1.54672 9.09011 1.08712 9.52756C1.01641 9.59755 0.910354 9.69379 0.768939 9.81627C0.627525 9.93876 0.468434 10 0.291667 10Z\" fill=\"black\"/>\n  </svg>\n  ";
    trigger.addEventListener("click", function () {
      openMobileFilters(filterForm);
    });
    toolbar.prepend(trigger);
  }
  document.addEventListener("click", function (e) {
    var closeBtn = e.target.closest(".js-close-filters");
    if (closeBtn) {
      var form = closeBtn.closest(".filterForm");
      if (form) closeMobileFilters(form);
    }
  });
  function setupPriceInputEvents() {
    var minPriceInput = document.getElementById("min-price-input");
    var maxPriceInput = document.getElementById("max-price-input");
    var inputRangeSlider = document.getElementById("input-range-slider");
    var bottomContainer = document.querySelector(".filterActionContainer--bottom");
    if (!bottomContainer) return;
    var showBottomAction = function showBottomAction() {
      bottomContainer.classList.add("is-visible");
    };

    // 1. Escuta nos inputs numéricos
    minPriceInput === null || minPriceInput === void 0 || minPriceInput.addEventListener("change", showBottomAction);
    maxPriceInput === null || maxPriceInput === void 0 || maxPriceInput.addEventListener("change", showBottomAction);

    // 2. Escuta no input hidden (caso a plataforma/lib dê um .trigger('change'))
    inputRangeSlider === null || inputRangeSlider === void 0 || inputRangeSlider.addEventListener("change", showBottomAction);

    // 3. Suporte ao jQuery UI Slider (caso o slider atualize o input hidden ao arrastar)
    if (window.jQuery && $("#slider-range").length) {
      $("#slider-range").on("slidechange slide", showBottomAction);
    }

    // 4. Garantia via MutationObserver: dispara se o atributo 'value' do input hidden mudar no DOM
    if (inputRangeSlider) {
      var observer = new MutationObserver(showBottomAction);
      observer.observe(inputRangeSlider, {
        attributes: true,
        attributeFilter: ["value"]
      });
    }
  }

  // Inicializa
  setupPriceInputEvents();
  insertMobileFilterTrigger();
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _cache) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.checkLoginAndUpdateLoginDrawer = checkLoginAndUpdateLoginDrawer;
  _exports.clearLoginCache = clearLoginCache;
  function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
  function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
  function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
  function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
  var CHECK_LOGIN_URL = "/index.php?route=common/account/checkLogin";
  var LOGIN_CACHE_KEY = "rosealianca_login";
  var loginCheckPromise = null;
  var loginCheckPerformed = false;
  var loginCacheData = null;
  function getCachedLoginData() {
    return (0, _cache.getCacheData)(LOGIN_CACHE_KEY);
  }
  function saveLoginCache(data) {
    if (!data.logged) {
      clearLoginCache();
      return;
    }
    var payload = {
      status: data.status || "logged",
      logged: true,
      customer_id: data.customer_id || null,
      customer_name: data.customer_name || "",
      customer_email: data.customer_email || ""
    };
    (0, _cache.setCacheData)(LOGIN_CACHE_KEY, payload, 1000 * 60 * 60 * 24);
    loginCacheData = payload;
  }
  function clearLoginCache() {
    loginCheckPerformed = false;
    loginCheckPromise = null;
    loginCacheData = null;
    localStorage.removeItem(LOGIN_CACHE_KEY);
  }
  function getLoginDrawerElements() {
    return {
      loginAction: document.getElementById("drawer-login-action"),
      accountMenuAction: document.getElementById("drawer-account-menu-action"),
      registerAction: document.getElementById("drawer-register-action")
    };
  }
  function setLoginDrawerLoadingState(isLoading) {
    var _getLoginDrawerElemen = getLoginDrawerElements(),
      loginAction = _getLoginDrawerElemen.loginAction,
      accountMenuAction = _getLoginDrawerElemen.accountMenuAction,
      registerAction = _getLoginDrawerElemen.registerAction;
    var buttons = [loginAction, accountMenuAction, registerAction].filter(Boolean);
    buttons.forEach(function (button) {
      var label = button.querySelector("span");
      if (isLoading) {
        button.href = "#";
        button.setAttribute("aria-busy", "true");
        button.style.pointerEvents = "none";
        if (label) label.textContent = button === registerAction ? "Aguarde..." : "Carregando...";
      } else {
        button.removeAttribute("aria-busy");
        button.style.pointerEvents = "";
      }
    });
  }
  function updateLoginDrawerLinks(loggedIn) {
    var _getLoginDrawerElemen2 = getLoginDrawerElements(),
      loginAction = _getLoginDrawerElemen2.loginAction,
      accountMenuAction = _getLoginDrawerElemen2.accountMenuAction,
      registerAction = _getLoginDrawerElemen2.registerAction;
    var updateButton = function updateButton(element, isAccount) {
      if (!element) return;
      var textSpan = element.querySelector("span");
      if (loggedIn) {
        element.href = element.dataset.accountHref || "/minha-conta";
        if (textSpan) textSpan.textContent = element.dataset.accountText || "Minha Conta";
      } else {
        element.href = element.dataset.defaultHref || "/login";
        if (textSpan) textSpan.textContent = element.dataset.defaultText || "Entrar";
      }
    };
    updateButton(loginAction);
    updateButton(accountMenuAction);
    if (registerAction) {
      var registerText = registerAction.querySelector("span");
      if (loggedIn) {
        registerAction.href = registerAction.dataset.logoutHref || "/logout";
        if (registerText) registerText.textContent = registerAction.dataset.logoutText || "Sair";
      } else {
        registerAction.href = registerAction.dataset.defaultHref || "/cadastro";
        if (registerText) registerText.textContent = registerAction.dataset.defaultText || "Cadastrar";
      }
    }
  }
  function checkLoginAndUpdateLoginDrawer() {
    return _checkLoginAndUpdateLoginDrawer.apply(this, arguments);
  }
  function _checkLoginAndUpdateLoginDrawer() {
    _checkLoginAndUpdateLoginDrawer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var cachedData;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (!loginCacheData) {
              _context2.n = 1;
              break;
            }
            loginCheckPerformed = true;
            updateLoginDrawerLinks(!!loginCacheData.logged);
            return _context2.a(2, loginCacheData);
          case 1:
            cachedData = getCachedLoginData();
            if (!cachedData) {
              _context2.n = 2;
              break;
            }
            loginCheckPerformed = true;
            loginCacheData = cachedData;
            updateLoginDrawerLinks(!!cachedData.logged);
            return _context2.a(2, cachedData);
          case 2:
            if (!loginCheckPromise) {
              _context2.n = 3;
              break;
            }
            return _context2.a(2, loginCheckPromise);
          case 3:
            loginCheckPerformed = true;
            loginCheckPromise = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
              var response, json, _t;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.p = _context.n) {
                  case 0:
                    setLoginDrawerLoadingState(true);
                    _context.p = 1;
                    _context.n = 2;
                    return fetch(CHECK_LOGIN_URL, {
                      method: "GET",
                      credentials: "same-origin",
                      headers: {
                        Accept: "application/json"
                      }
                    });
                  case 2:
                    response = _context.v;
                    if (response.ok) {
                      _context.n = 3;
                      break;
                    }
                    throw new Error("Erro na requisi\xE7\xE3o. Status: ".concat(response.status));
                  case 3:
                    _context.n = 4;
                    return response.json();
                  case 4:
                    json = _context.v;
                    if (json.logged) {
                      saveLoginCache(json); // Salva no LocalStorage (persiste entre páginas)
                    } else {
                      clearLoginCache();
                      // Guarda em memória local que já validamos o "Não Logado" nesta página.
                      // Como o usuário precisa mudar de página ao logar, isso é 100% seguro.
                      loginCacheData = {
                        status: "not_logged",
                        logged: false,
                        message: "Não logado (Sessão verificada)"
                      };
                    }
                    updateLoginDrawerLinks(!!json.logged);
                    return _context.a(2, json);
                  case 5:
                    _context.p = 5;
                    _t = _context.v;
                    console.error("Erro via fetch:", _t);

                    // Em caso de erro de rede, também evita travar o cliente em loops de requisições
                    loginCacheData = {
                      status: "not_logged",
                      logged: false,
                      message: "Falha ao verificar status de login"
                    };
                    updateLoginDrawerLinks(false);
                    return _context.a(2, loginCacheData);
                  case 6:
                    _context.p = 6;
                    setLoginDrawerLoadingState(false);
                    loginCheckPromise = null;
                    return _context.f(6);
                  case 7:
                    return _context.a(2);
                }
              }, _callee, null, [[1, 5, 6, 7]]);
            }))();
            return _context2.a(2, loginCheckPromise);
        }
      }, _callee2);
    }));
    return _checkLoginAndUpdateLoginDrawer.apply(this, arguments);
  }
});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getCacheData = getCacheData;
  _exports.setCacheData = setCacheData;
  function setCacheData(key, value) {
    var ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000 * 60 * 60 * 6;
    var payload = {
      data: value,
      timestamp: Date.now(),
      ttl: ttl
    };
    localStorage.setItem(key, JSON.stringify(payload));
  }
  function getCacheData(key) {
    var cached = localStorage.getItem(key);
    if (!cached) return null;
    try {
      var _JSON$parse = JSON.parse(cached),
        data = _JSON$parse.data,
        timestamp = _JSON$parse.timestamp,
        ttl = _JSON$parse.ttl;
      var isValid = Date.now() - timestamp < ttl;
      return isValid ? data : null;
    } catch (err) {
      console.warn("Erro ao ler cache:", err);
      return null;
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _loader) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.calculateFreight = calculateFreight;
  _exports.deleteCartItem = deleteCartItem;
  _exports.updateCartDrawer = updateCartDrawer;
  function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
  function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
  function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
  function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
  function updateCartDrawer() {
    return new Promise(function (resolve, reject) {
      var bodyContainer = $("#drawer-cart .drawer__body");
      if (!bodyContainer.length) {
        console.warn("Elemento '.drawer__body' não foi encontrado no DOM.");
        return reject("Elemento não encontrado");
      }
      $.ajax({
        url: "index.php?route=common/cart/getCart",
        type: "GET",
        dataType: "json",
        success: function success(result) {
          if (result && result.cart_html) {
            // O jQuery limpa o antigo e executa as tags <script> automaticamente
            bodyContainer.html(result.cart_html);
          } else {
            console.warn("A resposta não possui a propriedade 'cart_html'.");
          }
          resolve(result);
        },
        error: function error(_error) {
          console.error("Erro ao atualizar o drawer do carrinho:", _error);
          reject(_error);
        }
      });
    });
  }
  function deleteCartItem(key) {
    if (!key) {
      console.warn("Nenhuma chave de produto foi fornecida para exclusão.");
      return;
    }
    $.ajax({
      url: "index.php?route=checkout/cart/remove",
      type: "post",
      data: "key=".concat(encodeURIComponent(key)),
      dataType: "json",
      beforeSend: function beforeSend() {
        if (typeof _loader.loader === "function") (0, _loader.loader)();
      },
      success: function success() {
        updateCartDrawer();
      },
      error: function error(response) {
        console.error("Erro ao remover item:", response.responseText);
      },
      complete: function complete() {
        if (typeof _loader.loader === "function") (0, _loader.loader)(false);
      }
    });
  }

  /**
   * Calcula o frete baseado no input de CEP informado e renderiza os resultados.
   */
  function calculateFreight() {
    return _calculateFreight.apply(this, arguments);
  }
  function _calculateFreight() {
    _calculateFreight = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var inputElement, resultsContainer, buttonElement, postcode, response, json, shippings, htmlResults, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            inputElement = document.querySelector("#drawer-cart-zip-code");
            resultsContainer = document.querySelector(".drawer-cart__freight-results");
            buttonElement = document.getElementById("drawer-cart-zip-code-button");
            if (!(!inputElement || !resultsContainer)) {
              _context.n = 1;
              break;
            }
            console.warn("Elementos do frete não encontrados no DOM.");
            return _context.a(2);
          case 1:
            // Sanitiza o CEP (mantém apenas números)
            postcode = inputElement.value.replace(/\D/g, ""); // Reset de estados das classes de erro e vazia
            inputElement.classList.remove("error");
            resultsContainer.classList.remove("empty");
            resultsContainer.innerHTML = "<li>Buscando CEP...</li>";

            // Validação simples
            if (!(postcode.length < 8)) {
              _context.n = 2;
              break;
            }
            inputElement.classList.add("error");
            resultsContainer.innerHTML = '<li class="cart__freight-error">CEP inválido</li>';
            return _context.a(2);
          case 2:
            // Estado de loading no botão (Substituindo o antigo plugin .button do jQuery)
            if (buttonElement) {
              buttonElement.disabled = true;
              buttonElement.dataset.originalText = buttonElement.textContent;
              buttonElement.textContent = buttonElement.getAttribute("data-loading-text") || "Carregando...";
            }
            _context.p = 3;
            _context.n = 4;
            return fetch("index.php?route=module/shipping/quote", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              },
              body: "postcode=".concat(encodeURIComponent(postcode))
            });
          case 4:
            response = _context.v;
            if (response.ok) {
              _context.n = 5;
              break;
            }
            throw new Error("Erro na requisi\xE7\xE3o. Status: ".concat(response.status));
          case 5:
            _context.n = 6;
            return response.json();
          case 6:
            json = _context.v;
            shippings = json.shipping_method;
            if (!(!shippings || Object.keys(shippings).length === 0)) {
              _context.n = 7;
              break;
            }
            resultsContainer.innerHTML = "<li>Não é possível calcular o frete neste momento.</li>";
            return _context.a(2);
          case 7:
            htmlResults = []; // Itera sobre as empresas de frete (ex: Jadlog, Correios)
            Object.values(shippings).forEach(function (shipping) {
              var deliveryTimeMessage = shipping.delivery_time || "";

              // Itera sobre os serviços específicos da empresa (ex: Sedex, Pac)
              Object.values(shipping.quote).forEach(function (service) {
                // Normaliza para array caso o backend envie ora como array, ora como objeto
                var carriers = Array.isArray(service) ? service : [service];
                carriers.forEach(function (carrier) {
                  // Constrói a mensagem de prazo padrão de produção + entrega
                  var totalDays = (parseInt(carrier.product_additional_time) || 0) + (parseInt(carrier.shipping_days) || 0);
                  var textPlural = totalDays > 1 ? "dias úteis" : "dia útil";
                  var defaultDeliveryText = "".concat(carrier.product_additional_time, " ").concat(carrier.product_additional_time > 1 ? "dias úteis" : "dia útil", " para produ\xE7\xE3o + ").concat(carrier.shipping_days, " ").concat(carrier.shipping_days > 1 ? "dias úteis" : "dia útil", " para entrega");
                  var finalDeliveryTime = deliveryTimeMessage.length > 0 ? deliveryTimeMessage : defaultDeliveryText;
                  htmlResults.push("\n            <li class=\"cart-freight__result\">\n              <div class=\"cart-freight__info\">\n                <p>\n                  <strong class=\"cart-freight-title\">".concat(carrier.title, "</strong> -\n                  <span class=\"cart-freight-delivery_time\">").concat(finalDeliveryTime, "</span> -\n                  <span class=\"cart-freight__price\">").concat(carrier.text, "</span>\n                </p>\n                ").concat(carrier.info ? "<p class=\"cart-freight__subinfo\">".concat(carrier.info, "</p>") : "", "\n              </div>\n            </li>\n          "));
                });
              });
            });

            // Adiciona a nota de rodapé obrigatória
            htmlResults.push("\n      <li class=\"cart-freight__result\">\n        <small>*Ap\xF3s confirma\xE7\xE3o do pagamento</small>\n      </li>\n    ");
            resultsContainer.innerHTML = htmlResults.join("");
            _context.n = 9;
            break;
          case 8:
            _context.p = 8;
            _t = _context.v;
            console.error("Erro ao calcular frete:", _t);
            resultsContainer.innerHTML = "<li>Falha ao calcular frete. Tente novamente.</li>";
          case 9:
            _context.p = 9;
            // Remove o estado de loading do botão
            if (buttonElement) {
              buttonElement.disabled = false;
              buttonElement.textContent = buttonElement.dataset.originalText;
            }
            return _context.f(9);
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[3, 8, 9, 10]]);
    }));
    return _calculateFreight.apply(this, arguments);
  }
});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.loader = loader;
  function loader() {
    var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var body = document.body;
    var bgLoader = document.getElementById('bgLoader');
    if (bgLoader) {
      bgLoader.remove();
      body.classList.remove('overflow-hidden');
    }
    if (open) {
      var htmlString = "\n        <div class=\"loader-content\" id=\"bgLoader\">\n            <div role=\"status\" class=\"loader-spinner\">\n                <svg aria-hidden=\"true\" class=\"loader-spinner__svg\" viewBox=\"0 0 100 101\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z\" fill=\"currentFill\"/><path d=\"M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z\" fill=\"currentColor\"/></svg>\n                <span class=\"sr-only\">Carregando...</span>\n            </div>\n        </div>\n        ";
      body.insertAdjacentHTML('beforeend', htmlString);
      body.classList.add('overflow-hidden');
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (buy_together) {
  "use strict";

  buy_together = _interopRequireWildcard(buy_together);
  function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
  $(function () {
    var PRODUCT_PAGE = document.querySelector(".page-product-product");
    if (PRODUCT_PAGE) {
      var mainCarousel = document.querySelector(".productMainCarousel");
      if (mainCarousel && mainCarousel.swiper) {
        mainCarousel.swiper.destroy();
        var mainSwiper = new Swiper(mainCarousel, {
          slidesPerView: 1,
          loop: true,
          spaceBetween: 0,
          enable: true,
          breakpoints: {
            640: {
              slidesPerView: 1,
              enabled: true
            },
            1440: {
              enabled: false
            }
          },
          navigation: {
            nextEl: ".productMainCarousel .swiper-button-next",
            prevEl: ".productMainCarousel .swiper-button-prev"
          },
          pagination: {
            el: ".productMainCarousel .swiper-pagination"
          }
        });
      }
      var priceContainer = document.querySelector(".product-prices-content");
      if (priceContainer) {
        var preco = priceContainer.querySelector(".product-price-body");
        var card = priceContainer.closest(".product-item, .product-box") || priceContainer.parentElement;
        var botao = card ? card.querySelector(".product-buy-button-content") : null;
        if (preco && botao) {
          divWrapper("product-actions-wrapper", priceContainer, [preco, botao]);
        }
      }
      renderDescription();
      // renderBuyTogether();
    }
  });
  function divWrapper(className, container, items) {
    var novaDiv = document.createElement("div");
    novaDiv.className = className;
    items.forEach(function (item) {
      if (item) {
        novaDiv.appendChild(item);
      }
    });
    container.appendChild(novaDiv);
  }
  function renderDescription() {
    var description_tabs = document.querySelector(".module-html-content-148");
    var description_container = document.querySelector(".product-description-content");
    var product_container = document.querySelector(".product.product-single > .row > .col-md-7");
    if (description_container && product_container && description_tabs) {
      // 1. Mapeia os elementos de origem (dentro do container de descrição)
      var titleElement = description_container.querySelector(".title-description");
      var descriptionElement = description_container.querySelector(".product-description");

      // 2. Mapeia os destinos dentro do componente de abas (tabs)
      var homeTab = description_tabs.querySelector("#nav-home-tab");
      var homeContent = description_tabs.querySelector("#nav-home");

      // 3. Move o TEXTO do título para o botão da aba
      if (titleElement && homeTab) {
        homeTab.textContent = titleElement.textContent.trim();
      }

      // 4. Move o ELEMENTO da descrição para dentro do conteúdo da aba
      if (descriptionElement && homeContent) {
        homeContent.appendChild(descriptionElement);
      }

      // 5. MOVE A TAB INTEIRA para o final de product_container
      // O appendChild remove o elemento do local antigo e o joga para o final do destino automaticamente
      product_container.appendChild(description_tabs);
    }
  }
  function renderBuyTogether() {
    var container = document.querySelector(".buy-together-items");
    var wrapper = document.querySelector(".buy-together-items > .buy-together-items-content");
    var items = document.querySelectorAll(".buy-together-items > .buy-together-items-content > .buy-together");
    if (container && wrapper && items.length > 0) {
      container.classList.add("swiper");
      wrapper.classList.add("swiper-wrapper");

      // 4. Percorre cada item '.buy-together' adicionando a classe de slide
      items.forEach(function (item) {
        item.classList.add("swiper-slide");
      });

      // 5. Inicializa o Swiper
      new Swiper(container, {
        slidesPerView: 2,
        spaceBetween: 16
      });
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12), __webpack_require__(9), __webpack_require__(13)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_toast, _loader, _buy_together_price) {
  "use strict";

  function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
  function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
  function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
  function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
  function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
  function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
  function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
  /* ==========================================================
     Sincronização entre as opções da página principal do produto
     e o select "espelho" do produto principal dentro do compre junto.
  
     - Página principal  -> muda o select do compre junto (produto principal)
     - Compre junto (main) -> muda o select da página principal (raro, mas cobre o caso)
     - O details do produto principal no compre junto fica sempre oculto,
       pois a seleção acontece pelos campos normais da página do produto.
  ========================================================== */

  var getMainPageSelect = function getMainPageSelect(productOptionId) {
    return document.querySelector("#input-option".concat(productOptionId));
  };
  var getBuyTogetherMainSelect = function getBuyTogetherMainSelect(productOptionId) {
    return document.querySelector("#product-buy-together__option".concat(productOptionId));
  };

  // Extrai o product_option_id de qualquer campo (select, input, textarea),
  // seja pelo data-product-option-id (input/textarea) ou pelo id do select
  var getProductOptionId = function getProductOptionId(field) {
    return field.dataset.productOptionId || (field.id ? field.id.replace("product-buy-together__option", "") : null);
  };
  var clearMainPageError = function clearMainPageError(select) {
    var formGroup = select === null || select === void 0 ? void 0 : select.closest(".form-group");
    if (!formGroup) return;
    formGroup.classList.remove("has-error");
    var errorMsg = formGroup.querySelector(".error-msg");
    if (errorMsg) errorMsg.remove();
  };
  var showMainPageError = function showMainPageError(select) {
    var formGroup = select === null || select === void 0 ? void 0 : select.closest(".form-group.required");
    if (!formGroup) return;
    formGroup.classList.add("has-error");
    if (formGroup.querySelector(".error-msg")) return; // já existe, não duplica

    var errorDiv = document.createElement("div");
    errorDiv.className = "error-msg text-danger";
    errorDiv.setAttribute("style", "");
    errorDiv.textContent = "Por favor, selecione uma opção.";
    formGroup.appendChild(errorDiv);
  };
  var scrollToOptionsList = function scrollToOptionsList() {
    var optionsList = document.querySelector(".options-list");
    if (!optionsList) return;
    optionsList.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  };
  var initMainProductOptionsSync = function initMainProductOptionsSync(buyTogetherRoot) {
    var btMainItem = buyTogetherRoot.querySelector(".product-buy-together__item--main");
    if (!btMainItem) return;

    // O details de opções do produto principal no compre junto fica sempre oculto
    var btMainDetails = btMainItem.querySelector(".product-buy-together__options");
    if (btMainDetails) {
      btMainDetails.style.display = "none";
    }

    // Pega select, input de texto e textarea do produto principal no compre junto
    var btMainFields = btMainItem.querySelectorAll(['select[id^="product-buy-together__option"]', "input.product-buy-together__option", "textarea[data-product-option-id]"].join(", "));
    btMainFields.forEach(function (btField) {
      var productOptionId = getProductOptionId(btField);
      if (!productOptionId) return;
      var mainPageField = getMainPageSelect(productOptionId);
      if (!mainPageField) return;

      // Sincroniza valor inicial (caso a página já carregue com algo preenchido)
      if (mainPageField.value && mainPageField.value !== "") {
        btField.value = mainPageField.value;
      }

      // Página principal -> Compre junto (única direção; o campo do compre
      // junto fica oculto e serve só de "espelho" para o envio do form)
      mainPageField.addEventListener("change", function () {
        btField.value = mainPageField.value;
        btField.dispatchEvent(new Event("change", {
          bubbles: true
        }));
        clearMainPageError(mainPageField);
      });
      // "input" cobre digitação em tempo real nos campos de texto/textarea
      mainPageField.addEventListener("input", function () {
        btField.value = mainPageField.value;
        clearMainPageError(mainPageField);
      });
    });
  };

  /*Adição dos produtos no compre junto */
  window.addBuyTogetherToCart = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var form, formData, data, main_product, csrf, buy_together_products, buildProductData, allProducts, anySuccess, _iterator2, _step2, product_id, productData, _json$error, response, json, _json$error2, msg, _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          form = document.querySelector("#product-buy-together__form");
          if (form) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          formData = new FormData(form);
          data = Object.fromEntries(formData.entries());
          main_product = data["main_product"];
          csrf = data["__csrf"];
          buy_together_products = formData.getAll("buy_together_products[]");
          buildProductData = function buildProductData(product_id) {
            var params = new URLSearchParams();
            params.append("product_id", product_id);
            params.append("quantity", 1);
            params.append("__csrf", csrf);
            var _iterator = _createForOfIteratorHelper(formData.entries()),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _step$value = _slicedToArray(_step.value, 2),
                  key = _step$value[0],
                  value = _step$value[1];
                var match = key.match(/^option\[(\d+)\]\[(\d+)\]$/);
                if (match) {
                  var productKey = match[1];
                  var optionId = match[2];
                  if (productKey === product_id) {
                    params.append("option[".concat(optionId, "]"), value);
                  }
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            return params;
          };
          allProducts = [main_product].concat(_toConsumableArray(buy_together_products));
          anySuccess = false; // ✅ para saber se algum produto foi adicionado com sucesso
          // === Mostrar loader ===
          (0, _loader.loader)();
          _iterator2 = _createForOfIteratorHelper(allProducts);
          _context.p = 2;
          _iterator2.s();
        case 3:
          if ((_step2 = _iterator2.n()).done) {
            _context.n = 10;
            break;
          }
          product_id = _step2.value;
          productData = buildProductData(product_id);
          _context.p = 4;
          _context.n = 5;
          return fetch("index.php?route=checkout/cart/add", {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest"
            },
            body: new URLSearchParams(productData)
          });
        case 5:
          response = _context.v;
          _context.n = 6;
          return response.json();
        case 6:
          json = _context.v;
          if (!(json.error_stock || json.error || (_json$error = json.error) !== null && _json$error !== void 0 && _json$error.login_required)) {
            _context.n = 7;
            break;
          }
          msg = json.error_stock || ((_json$error2 = json.error) === null || _json$error2 === void 0 ? void 0 : _json$error2.login_required) || "Confirme se todas as opções dos produtos selecionados estão preenchidas.";
          (0, _toast.createToast)({
            title: "Erro",
            message: msg,
            type: "error",
            timeout: 8000
          });
          return _context.a(3, 9);
        case 7:
          // ==== SUCESSO ====
          if (json.success) {
            anySuccess = true;
            (0, _toast.createToast)({
              message: "Produto Adicionado ao carrinho!"
            });
          }

          // ==== GA4 ====
          if (json.ga4) {
            window.ga4_cart_items = window.ga4_cart_items || [];
            window.ga4_cart_total = window.ga4_cart_total || 0;
            ga4_cart_items.push(json.add_to_cart);
            ga4_cart_total += Number(json.item_price);
          }
          _context.n = 9;
          break;
        case 8:
          _context.p = 8;
          _t = _context.v;
          console.error("Erro ao adicionar produto ao carrinho:", _t);
          (0, _toast.createToast)({
            title: "Erro",
            message: "Não foi possível adicionar o produto ao carrinho.",
            type: "error"
          });
        case 9:
          _context.n = 3;
          break;
        case 10:
          _context.n = 12;
          break;
        case 11:
          _context.p = 11;
          _t2 = _context.v;
          _iterator2.e(_t2);
        case 12:
          _context.p = 12;
          _iterator2.f();
          return _context.f(12);
        case 13:
          // === Ocultar loader ===
          (0, _loader.loader)(false);

          // === Se algum produto foi adicionado, redireciona para o carrinho ===
          if (anySuccess) {
            window.location.href = "/carrinho";
          }
        case 14:
          return _context.a(2);
      }
    }, _callee, null, [[4, 8], [2, 11, 12, 13]]);
  }));
  var HAS_BUY_TOGETHER = document.querySelector(".product-buy-together");
  if (HAS_BUY_TOGETHER) {
    (0, _buy_together_price.initBuyTogetherPriceCalc)(HAS_BUY_TOGETHER);
    initMainProductOptionsSync(HAS_BUY_TOGETHER);
    document.querySelector(".product-buy-together__add-to-cart").addEventListener("click", function (e) {
      e.preventDefault();
      var form = document.querySelector("#product-buy-together__form");
      if (!form) return;

      // Produto principal (sempre validar)
      var mainItem = form.querySelector(".product-buy-together__item--main");

      // Produtos opcionais checados
      var checkedOptionals = Array.from(form.querySelectorAll('.product-buy-together__item--optional input[type="checkbox"]:checked')).map(function (cb) {
        return cb.closest(".product-buy-together__item");
      });

      // Lista final de produtos a validar
      var itemsToValidate = [];
      if (mainItem) itemsToValidate.push(mainItem);
      checkedOptionals.forEach(function (item) {
        if (item && !itemsToValidate.includes(item)) itemsToValidate.push(item);
      });
      var hasError = false;
      var mainItemHasError = false;
      var errorLines = [];
      itemsToValidate.forEach(function (productItem) {
        var _productItem$querySel, _productItem$querySel2;
        var isMainItem = productItem.classList.contains("product-buy-together__item--main");
        var productName = ((_productItem$querySel = productItem.querySelector(".product-buy-together__name")) === null || _productItem$querySel === void 0 || (_productItem$querySel = _productItem$querySel.textContent) === null || _productItem$querySel === void 0 ? void 0 : _productItem$querySel.trim()) || ((_productItem$querySel2 = productItem.querySelector(".product-buy-together__name a")) === null || _productItem$querySel2 === void 0 || (_productItem$querySel2 = _productItem$querySel2.textContent) === null || _productItem$querySel2 === void 0 ? void 0 : _productItem$querySel2.trim()) || "Produto";
        var itemHasError = false;
        if (isMainItem) {
          // Todos os campos espelhados do produto principal no compre junto
          // (independente de terem ou não o atributo "required" nesse HTML,
          // que às vezes não é impresso corretamente pro input de texto)
          var btFields = productItem.querySelectorAll(['select[id^="product-buy-together__option"]', "input.product-buy-together__option", "textarea[data-product-option-id]"].join(", "));
          btFields.forEach(function (btField) {
            var productOptionId = getProductOptionId(btField);
            var mainPageField = getMainPageSelect(productOptionId);
            if (!mainPageField) return;

            // A obrigatoriedade é decidida pelo campo REAL da página do
            // produto: atributo "required" OU data-option-required="1"
            var isRequired = mainPageField.hasAttribute("required") || mainPageField.dataset.optionRequired === "1";
            if (!isRequired) return;

            // Fonte da verdade é sempre o campo real da página do produto
            var value = mainPageField.value;

            // Garante que o valor enviado no submit do form esteja correto
            btField.value = value;
            var invalid = value === "" || value === "0";
            if (invalid) {
              itemHasError = true;
              hasError = true;
              mainItemHasError = true;
              btField.classList.add("error");
              showMainPageError(mainPageField);
            } else {
              btField.classList.remove("error");
              clearMainPageError(mainPageField);
            }
          });
        } else {
          // Itens opcionais: só pega opções com atributo required
          var optionFields = Array.from(new Set([].concat(_toConsumableArray(productItem.querySelectorAll(".product-buy-together__option[required]")), _toConsumableArray(productItem.querySelectorAll("textarea[data-product-option-id][required]")))));
          optionFields.forEach(function (field) {
            var value = field.value;
            var invalid = value === "" || value === "0";
            if (invalid) {
              itemHasError = true;
              hasError = true;
              field.classList.add("error");
              var optionsContainer = productItem.querySelector(".product-buy-together__options");
              if (optionsContainer && optionsContainer.tagName === "DETAILS") {
                optionsContainer.open = true;
              }
            } else {
              field.classList.remove("error");
            }
          });
        }
        if (itemHasError) {
          errorLines.push("".concat(productName));
        }
      });
      if (hasError) {
        (0, _toast.createToast)({
          title: "Erro",
          message: "Escolha as opções obrigatórias para: </br>" + errorLines.join(", ") + "." || 0,
          type: "error",
          timeout: 8000
        });
        if (mainItemHasError) {
          scrollToOptionsList();
        }
        return;
      }

      // Tudo certo → adiciona ao carrinho
      addBuyTogetherToCart();
    });
  }
});

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.createToast = createToast;
  /** ANCHOR - Função para gerar toast
   * [createToast - Função gera um pequeno alerta que surge no topo direito da página que some após um tempo]
   * @author Eduardo de Paula Xavier eduardo.xavier@irroba.com.br
   * @objParam  [title: STRING Titulo do alerta]
   * @objParam  [message: STRING Mensagem descritiva do alerta]
   * @objParam  [type: STRING tipo do alerta, apenas success|info|error|warning irão gerar as cores e os ícones desejados ]
   * @objParam  [timeout: NUMBER tempo em ms que o alerta irá ser exibido até que ele desapareça]
   * @return [void: por padrão será mostrado um alerta de confirmação com mensagem e título genéricos]
   */

  function createToast() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Sucesso" : _ref$title,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? "Dados cadastrados com sucesso" : _ref$message,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "success" : _ref$type,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 3000 : _ref$timeout;
    var body = document.querySelector("body");
    var existingDiv = document.getElementById("toastContainer");
    if (!existingDiv) {
      var newDiv = document.createElement("div");
      newDiv.setAttribute("id", "toastContainer");
      newDiv.setAttribute("class", "toast-container");
      body.appendChild(newDiv);
    }
    var toastContainer = document.getElementById("toastContainer");
    var toast = document.createElement("div");
    toast.className = "toast-item";
    toast.innerHTML = "\n        <div class=\"toast-content flex justify-between p-4 gap-2 w-full\">\n          <div class=\"toast-content__icon\">\n            ".concat(getIcon(type), "\n          </div>\n          <div class=\"toast-content__dialog\">\n              <h6 class=\"toast-content__title\">").concat(title, "</h6>\n              <div class=\"toast-content__message\">\n                    <span>").concat(message, "</span>\n                </div>\n          </div>\n          <button role=\"button\" class=\"toast-content__button-close\" onclick=\"window.removeToast(this.closest('.toast-item'))\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"1rem\" viewBox=\"0 -960 960 960\" width=\"1rem\" fill=\"#e8eaed\"><path d=\"m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z\"/></svg>\n          </button>\n\n        </div>\n        <div class=\"toast-progress-bar\">\n            <span class=\"toast-progress-bar__percentage toast-progress-bar__percentage--").concat(type, "\" style=\"animation: growRight ").concat(timeout / 1000, "s ease infinite forwards ;\"></span>\n        </div>\n    ");
    toastContainer.appendChild(toast);
    setTimeout(function () {
      window.removeToast(toast);
    }, timeout);
  }
  window.removeToast = function (toast) {
    if (toast.parentNode) {
      toast.parentNode.removeChild(toast);
    }
  };
  function getIcon(type) {
    if (type === "info") {
      return "\n      <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"toast-info\" height=\"24px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"#e8eaed\"><path d=\"M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z\"/></svg>\n      ";
    } else if (type === "success") {
      return "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"toast-success\" height=\"24px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"#e8eaed\">\n        <path d=\"m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z\"/>\n        </svg>\n          ";
    } else if (type === "warning") {
      return "\n          <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"toast-warning\" height=\"24px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"#e8eaed\"><path d=\"m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z\"/></svg>\n      ";
    } else if (type === "error") {
      return "\n            <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"toast-error\" height=\"24px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"#e8eaed\"><path d=\"M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z\"/></svg>\n          ";
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _number_formatter) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.calculateBuyTogetherProduct = calculateBuyTogetherProduct;
  _exports.calculateBuyTogetherTotal = calculateBuyTogetherTotal;
  _exports.initBuyTogetherPriceCalc = initBuyTogetherPriceCalc;
  /**
   * Calcula preço/desconto de um item do compre junto, somando/subtraindo
   * o valor das opções selecionadas.
   */
  function calculateBuyTogetherProduct(product_item) {
    var product_price_element = product_item.querySelector(".product-buy-together__price");
    var product_price_special_element = product_item.querySelector(".product-buy-together__price-special");
    var product_discount_element = product_item.querySelector(".product-buy-together__discount-value");
    var product_option_elements = product_item.querySelectorAll(".product-buy-together__option");
    var price = Number(product_price_element.dataset.priceWithoutFormat);
    var special_price = product_price_special_element ? Number(product_price_special_element.dataset.priceWithoutFormat) : 0;
    var discount = product_discount_element ? Number(product_discount_element.dataset.priceDiscountWithoutFormat) : 0;
    product_option_elements.forEach(function (product_option_element) {
      var option_selected_element = product_option_element.tagName === "SELECT" ? product_option_element.selectedOptions[0] : product_option_element;
      var option_price = option_selected_element !== null && option_selected_element !== void 0 && option_selected_element.dataset.optionPrice ? Number(option_selected_element.dataset.optionPrice) : 0;
      var option_prefix = option_selected_element !== null && option_selected_element !== void 0 && option_selected_element.dataset.optionPricePrefix ? option_selected_element.dataset.optionPricePrefix : "+";
      if (option_prefix == "+") {
        price = price + option_price;
        if (special_price) special_price = special_price + option_price;
        if (discount) discount = discount + option_price;
      } else {
        price = price - option_price;
        special_price = special_price - option_price;
        discount = discount - option_price;
      }
    });
    return {
      price: price,
      special_price: special_price,
      discount: discount,
      product_price_element: product_price_element,
      product_price_special_element: product_price_special_element,
      product_discount_element: product_discount_element
    };
  }

  /**
   * Recalcula o total exibido em ".product-buy-together__total" dentro
   * do container informado (permite reaproveitar em produto e combo).
   */
  function calculateBuyTogetherTotal() {
    var _buy_together_parcel_;
    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var buy_together_total = container.querySelector(".product-buy-together__total");
    var buy_together_list = container.querySelector(".product-buy-together__list");
    var buy_together_main_product = container.querySelector(".product-buy-together__item--main");
    if (!buy_together_total || !buy_together_list || !buy_together_main_product) {
      return;
    }
    var buy_together_products = buy_together_list.querySelectorAll(".product-buy-together__item");
    var main_product_calculated = calculateBuyTogetherProduct(buy_together_main_product);
    var total_price = main_product_calculated.price;
    var total_special = main_product_calculated.special_price ? main_product_calculated.special_price : main_product_calculated.price;
    var has_special = main_product_calculated.special_price ? true : false;
    buy_together_products.forEach(function (product_item) {
      var product_checkbox = product_item.querySelector(".product-buy-together__checkbox input");
      if (product_checkbox !== null && product_checkbox !== void 0 && product_checkbox.checked) {
        var product_calculated = calculateBuyTogetherProduct(product_item);
        total_price = total_price + product_calculated.price;
        if (product_calculated.special_price) {
          total_special = total_special + product_calculated.special_price;
          has_special = true;
        } else {
          total_special = total_special + product_calculated.price;
        }
      }
    });
    var buy_together_special_elements = buy_together_total.querySelectorAll(".product-buy-together__total-value-special");
    var buy_together_parcel_number_elements = buy_together_total.querySelectorAll(".product-buy-together__parcel-number");
    var buy_together_total_value_elements = buy_together_total.querySelectorAll(".product-buy-together__total-value");
    var buy_together_parcel_price_elements = buy_together_total.querySelectorAll(".product-buy-together__parcel-price");
    if (buy_together_special_elements.length && has_special) {
      buy_together_special_elements.forEach(function (element) {
        element.textContent = (0, _number_formatter.numberFormatToCurrency)(total_special);
      });
    } else if (!buy_together_special_elements.length && has_special) {
      var _buy_together_total_v;
      var specialValue = document.createElement("span");
      specialValue.className = "product-buy-together__total-value-special";
      specialValue.textContent = (0, _number_formatter.numberFormatToCurrency)(total_special);
      (_buy_together_total_v = buy_together_total_value_elements[0]) === null || _buy_together_total_v === void 0 || _buy_together_total_v.insertAdjacentElement("afterend", specialValue);
    } else if (buy_together_special_elements.length && !has_special) {
      buy_together_special_elements.forEach(function (element) {
        return element.remove();
      });
    }
    var total_installments = has_special ? total_special : total_price;
    var parcel_price = total_installments / Number(((_buy_together_parcel_ = buy_together_parcel_number_elements[0]) === null || _buy_together_parcel_ === void 0 ? void 0 : _buy_together_parcel_.textContent) || 1);
    buy_together_total_value_elements.forEach(function (element) {
      element.textContent = (0, _number_formatter.numberFormatToCurrency)(total_price);
    });
    buy_together_parcel_price_elements.forEach(function (element) {
      element.textContent = (0, _number_formatter.numberFormatToCurrency)(parcel_price);
    });
  }

  /**
   * Inicializa o cálculo de preço para um container ".product-buy-together"
   * específico: registra o handler global usado pelo onchange="btProductOption(this)"
   * e os listeners de clique dos checkboxes opcionais.
   */
  function initBuyTogetherPriceCalc() {
    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    window.btProductOption = function (element) {
      var product_item = element.closest(".product-buy-together__item");
      var product_checkbox = product_item.querySelector(".product-buy-together__checkbox input");
      var product_calculated = calculateBuyTogetherProduct(product_item);
      product_calculated.product_price_element.textContent = (0, _number_formatter.numberFormatToCurrency)(product_calculated.price);
      if (product_calculated.special_price && product_calculated.product_price_special_element) {
        product_calculated.product_price_special_element.textContent = (0, _number_formatter.numberFormatToCurrency)(product_calculated.special_price);
      }
      if (product_calculated.discount && product_calculated.product_discount_element) {
        product_calculated.product_discount_element.textContent = (0, _number_formatter.numberFormatToCurrency)(product_calculated.discount);
      }
      if (element.value != "0" && product_checkbox) {
        product_checkbox.checked = true;
      } else if (product_checkbox) {
        product_checkbox.checked = false;
      }
      calculateBuyTogetherTotal(container);
    };
    container.querySelectorAll(".product-buy-together__checkbox").forEach(function (checkbox) {
      checkbox.addEventListener("click", function () {
        calculateBuyTogetherTotal(container);
      });
    });
  }
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_cart, _combo_buy_together) {
  "use strict";

  function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
  function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
  function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
  function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
  var comboPage = document.querySelector(".page-product-Combo-getComboPage");
  if (comboPage) {
    renderDescription();
  }
  function renderDescription() {
    var descriptionTabs = document.querySelector(".module-html-content-148");
    var descriptionContent = document.querySelector(".combo-description-content");
    var descriptionContainer = document.querySelector(".combo-description");
    if (descriptionContainer && descriptionContent && descriptionTabs) {
      var titleElement = descriptionContainer.querySelector(".combo-description-title");
      var homeTab = descriptionTabs.querySelector("#nav-home-tab");
      var homeContent = descriptionTabs.querySelector("#nav-home");
      if (titleElement && homeTab) {
        homeTab.textContent = titleElement.textContent.trim();
        titleElement.remove();
      }
      // 4. Move o ELEMENTO da descrição para dentro do conteúdo da aba
      if (descriptionContent && homeContent) {
        homeContent.appendChild(descriptionContent);
      }

      // 5. MOVE A TAB INTEIRA para o final de product_container
      // O appendChild remove o elemento do local antigo e o joga para o final do destino automaticamente
      descriptionContainer.appendChild(descriptionTabs);
    }
  }
  window.addEventListener("openCartEvent", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          // 1. Abre o componente visual do drawer do carrinho
          if (typeof openDrawer === "function") {
            openDrawer("drawer-cart");
          }

          // 2. Roda a função para buscar e atualizar os dados/HTML via Ajax
          _context.p = 1;
          _context.n = 2;
          return (0, _cart.updateCartDrawer)();
        case 2:
          console.log("Drawer do carrinho aberto e atualizado com sucesso via evento!");
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          console.error("Erro ao atualizar o carrinho após o evento:", _t);
        case 4:
          return _context.a(2);
      }
    }, _callee, null, [[1, 3]]);
  })));
});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12), __webpack_require__(9), __webpack_require__(4), __webpack_require__(13)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_toast, _loader, _number_formatter, _buy_together_price) {
  "use strict";

  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
  function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
  function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
  function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
  function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
  function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  var COMBO_BUY_TOGETHER = document.querySelector(".product-buy-together--combo");
  var CART_URL = "/carrinho";

  /**
   * Atualiza o preço exibido no item principal (combo) do compre-junto,
   * usando os valores retornados pela simulação de preço do combo.
   * @param {HTMLElement} container - .product-buy-together--combo
   * @param {{price: number, in_cash_price: number}} comboData
   */
  function updateComboMainPrice(container, comboData) {
    var mainItem = container.querySelector(".product-buy-together__item--main");
    if (!mainItem) return;
    var priceEl = mainItem.querySelector(".product-buy-together__price");
    var specialEl = mainItem.querySelector(".product-buy-together__price-special");
    if (priceEl) {
      priceEl.dataset.priceWithoutFormat = comboData.price;
      priceEl.textContent = (0, _number_formatter.numberFormatToCurrency)(comboData.price);
    }
    if (comboData.in_cash_price) {
      if (specialEl) {
        specialEl.dataset.priceWithoutFormat = comboData.in_cash_price;
        specialEl.textContent = (0, _number_formatter.numberFormatToCurrency)(comboData.in_cash_price);
      } else if (priceEl) {
        // Cria o elemento caso ele não exista ainda no markup
        var newSpecial = document.createElement("span");
        newSpecial.className = "product-buy-together__price-special";
        newSpecial.dataset.priceWithoutFormat = comboData.in_cash_price;
        newSpecial.textContent = (0, _number_formatter.numberFormatToCurrency)(comboData.in_cash_price);
        priceEl.insertAdjacentElement("afterend", newSpecial);
      }
    } else if (specialEl) {
      // Sem desconto: remove o preço especial se existir
      specialEl.remove();
    }
  }

  /**
   * Callback disparado externamente (fora deste módulo) sempre que a simulação
   * de preço do combo é recalculada. Atualiza os preços exibidos no compre-junto
   * e recalcula o total exibido, já que ele lê os data-price-without-format.
   */
  window.afterUpdateComboPrice = function (json) {
    if (!COMBO_BUY_TOGETHER || !json) return;
    if (json.combo) {
      updateComboMainPrice(COMBO_BUY_TOGETHER, json.combo);
    }
    // Recalcula o total do compre-junto com os novos valores
    (0, _buy_together_price.calculateBuyTogetherTotal)(COMBO_BUY_TOGETHER);
  };
  if (COMBO_BUY_TOGETHER) {
    (0, _buy_together_price.initBuyTogetherPriceCalc)(COMBO_BUY_TOGETHER);
  }

  /**
   * Monta o corpo do checkout/cart/add de um produto do compre junto.
   * @param {FormData} form_data
   * @param {string} product_id
   * @returns {URLSearchParams}
   */
  function buildProductData(form_data, product_id) {
    var params = new URLSearchParams();
    params.append("product_id", product_id);
    params.append("quantity", 1);
    var _iterator = _createForOfIteratorHelper(form_data.entries()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];
        var match = key.match(/^option\[(\d+)\]\[(\d+)\]$/);
        if (match && match[1] === product_id) {
          params.append("option[".concat(match[2], "]"), value);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return params;
  }

  /**
   * Valida as opções obrigatórias dos produtos marcados no compre junto
   * @param {HTMLFormElement} form
   * @returns {boolean} true quando algum produto marcado está sem opção obrigatória
   */
  function hasInvalidOptions(form) {
    var checked_items = Array.from(form.querySelectorAll('.product-buy-together__item--optional input[type="checkbox"]:checked')).map(function (checkbox) {
      return checkbox.closest(".product-buy-together__item");
    });
    var invalid_products = [];
    checked_items.forEach(function (item) {
      var _item$querySelector;
      var name = ((_item$querySelector = item.querySelector(".product-buy-together__name")) === null || _item$querySelector === void 0 || (_item$querySelector = _item$querySelector.textContent) === null || _item$querySelector === void 0 ? void 0 : _item$querySelector.trim()) || "Produto";
      var item_has_error = false;
      item.querySelectorAll(".product-buy-together__option[required]").forEach(function (field) {
        if (field.value === "" || field.value === "0") {
          item_has_error = true;
          field.classList.add("error");
          var options = item.querySelector(".product-buy-together__options");
          if (options && options.tagName === "DETAILS") {
            options.open = true;
          }
        } else {
          field.classList.remove("error");
        }
      });
      if (item_has_error) {
        invalid_products.push(name);
      }
    });
    if (invalid_products.length) {
      (0, _toast.createToast)({
        title: "Erro",
        message: "Escolha as opções obrigatórias para: </br>" + invalid_products.join(", ") + ".",
        type: "error",
        timeout: 8000
      });
    }
    return invalid_products.length > 0;
  }

  /**
   * Adiciona o combo ao carrinho pelo endpoint do combo, lendo o #combo-form da página.
   * @returns {Promise<boolean>} true quando o combo entrou no carrinho
   */
  function addComboToCart() {
    return _addComboToCart.apply(this, arguments);
  }
  /**
   * Adiciona um produto do compre junto ao carrinho
   * @param {URLSearchParams} product_data
   * @returns {Promise<boolean>} true quando o produto entrou no carrinho
   */
  function _addComboToCart() {
    _addComboToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var combo_form, params, combo_quantity, response, json, _json$errors;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            combo_form = document.querySelector("#combo-form");
            if (combo_form) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2, false);
          case 1:
            params = new URLSearchParams(new FormData(combo_form));
            combo_quantity = document.querySelector('input[name="combo_quantity"]');
            params.append("combo_quantity", combo_quantity ? combo_quantity.value : 1);
            _context2.n = 2;
            return fetch("index.php?route=product/Combo/handleComboCart", {
              method: "POST",
              headers: {
                "X-Requested-With": "XMLHttpRequest"
              },
              body: params
            });
          case 2:
            response = _context2.v;
            _context2.n = 3;
            return response.json();
          case 3:
            json = _context2.v;
            if (response.ok) {
              _context2.n = 4;
              break;
            }
            (0, _toast.createToast)({
              title: "Atenção",
              message: "Verifique os produtos e seus campos obrigatórios",
              type: "error",
              timeout: 5000
            });
            Object.entries((_json$errors = json.errors) !== null && _json$errors !== void 0 ? _json$errors : {}).forEach(function (_ref2) {
              var _document$getElementB;
              var _ref3 = _slicedToArray(_ref2, 2),
                combo_product_id = _ref3[0],
                errors = _ref3[1];
              (_document$getElementB = document.getElementById("combo-tab-".concat(combo_product_id))) === null || _document$getElementB === void 0 || _document$getElementB.classList.add("combo-tab--error");
              if (_typeof(errors) !== "object") {
                return;
              }
              Object.entries(errors).forEach(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                  option_id = _ref5[0],
                  message = _ref5[1];
                var option = document.getElementById("combo-tab__option-".concat(combo_product_id, "-").concat(option_id));
                if (option) {
                  option.classList.add("combo-tab__option--error");
                  option.querySelector(".combo-tab__error").innerHTML = message;
                }
              });
            });
            return _context2.a(2, false);
          case 4:
            return _context2.a(2, true);
        }
      }, _callee2);
    }));
    return _addComboToCart.apply(this, arguments);
  }
  function addProductToCart(_x) {
    return _addProductToCart.apply(this, arguments);
  }
  /**
   * Adiciona o combo e os produtos marcados do compre junto ao carrinho.
   * O combo é o item principal: se ele não entrar no carrinho (opção obrigatória do
   * #combo-form não preenchida, por exemplo), nada é adicionado e não redirecionamos,
   * para que o cliente possa corrigir os campos marcados com erro.
   */
  function _addProductToCart() {
    _addProductToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(product_data) {
      var response, json, _json$error;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return fetch("index.php?route=checkout/cart/add", {
              method: "POST",
              headers: {
                "X-Requested-With": "XMLHttpRequest"
              },
              body: product_data
            });
          case 1:
            response = _context3.v;
            _context3.n = 2;
            return response.json();
          case 2:
            json = _context3.v;
            if (!(json.error_stock || json.error || !json.success)) {
              _context3.n = 3;
              break;
            }
            (0, _toast.createToast)({
              title: "Erro",
              message: json.error_stock || ((_json$error = json.error) === null || _json$error === void 0 ? void 0 : _json$error.login_required) || "Confirme se todas as opções dos produtos selecionados estão preenchidas.",
              type: "error",
              timeout: 8000
            });
            return _context3.a(2, false);
          case 3:
            if (json.ga4) {
              window.ga4_cart_items = window.ga4_cart_items || [];
              window.ga4_cart_total = window.ga4_cart_total || 0;
              ga4_cart_items.push(json.add_to_cart);
              ga4_cart_total += Number(json.item_price);
            }
            return _context3.a(2, true);
        }
      }, _callee3);
    }));
    return _addProductToCart.apply(this, arguments);
  }
  window.addComboBuyTogetherToCart = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var form, form_data, products, combo_added, _iterator2, _step2, product_id, product_added, _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          form = document.querySelector("#combo-buy-together__form");
          if (form) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          form_data = new FormData(form);
          products = form_data.getAll("buy_together_products[]");
          (0, _loader.loader)();
          _context.n = 2;
          return addComboToCart();
        case 2:
          combo_added = _context.v;
          if (combo_added) {
            _context.n = 3;
            break;
          }
          (0, _loader.loader)(false);
          return _context.a(2);
        case 3:
          // O combo já está no carrinho. Cada produto do compre junto é independente:
          // a falha de um não impede os demais, e o cliente segue para o carrinho.
          _iterator2 = _createForOfIteratorHelper(products);
          _context.p = 4;
          _iterator2.s();
        case 5:
          if ((_step2 = _iterator2.n()).done) {
            _context.n = 10;
            break;
          }
          product_id = _step2.value;
          _context.p = 6;
          _context.n = 7;
          return addProductToCart(buildProductData(form_data, product_id));
        case 7:
          product_added = _context.v;
          if (product_added) {
            (0, _toast.createToast)({
              message: "Produto Adicionado ao carrinho!"
            });
          }
          _context.n = 9;
          break;
        case 8:
          _context.p = 8;
          _t = _context.v;
          console.error("Erro ao adicionar produto ao carrinho:", _t);
          (0, _toast.createToast)({
            title: "Erro",
            message: "Não foi possível adicionar o produto ao carrinho.",
            type: "error"
          });
        case 9:
          _context.n = 5;
          break;
        case 10:
          _context.n = 12;
          break;
        case 11:
          _context.p = 11;
          _t2 = _context.v;
          _iterator2.e(_t2);
        case 12:
          _context.p = 12;
          _iterator2.f();
          return _context.f(12);
        case 13:
          (0, _loader.loader)(false);
          window.location.href = CART_URL;
        case 14:
          return _context.a(2);
      }
    }, _callee, null, [[6, 8], [4, 11, 12, 13]]);
  }));
  if (COMBO_BUY_TOGETHER) {
    var _COMBO_BUY_TOGETHER$q;
    (_COMBO_BUY_TOGETHER$q = COMBO_BUY_TOGETHER.querySelector(".product-buy-together__add-to-cart")) === null || _COMBO_BUY_TOGETHER$q === void 0 ? void 0 : _COMBO_BUY_TOGETHER$q.addEventListener("click", function (event) {
      event.preventDefault();
      var form = document.querySelector("#combo-buy-together__form");
      if (!form || hasInvalidOptions(form)) {
        return;
      }
      addComboBuyTogetherToCart();
    });
  }
});

/***/ }),
/* 16 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
  "use strict";

  $(function () {
    var IS_INFO_PAGE = document.querySelector("body.page-information-information");
    var HISTORY = document.querySelector("body .information-content1");
    var CUSTOM_ORDER = document.querySelector("body .information-content17");
    if (IS_INFO_PAGE && HISTORY) {
      initHistoryPage();
    }
    if (IS_INFO_PAGE && CUSTOM_ORDER) {
      initCustomOrderPage();
    }
  });
  function initHistoryPage() {
    var stories = {
      gustavo: ["https://player.vimeo.com/video/1127951271?h=d701ba70bc", "https://player.vimeo.com/video/1127951375?h=8ab9f3e148", "https://player.vimeo.com/video/1127951447?h=f506873d9d", "https://player.vimeo.com/video/1127951483?h=7053865ef4", "https://player.vimeo.com/video/1127951582?h=0f9937b7a8"],
      gabriela: ["https://player.vimeo.com/video/1127953141?h=1c3f556ad3", "https://player.vimeo.com/video/1127953299?h=fb2dcf65e2", "https://player.vimeo.com/video/1127953407?h=2accadf180", "https://player.vimeo.com/video/1127953440?h=e281ede57e", "https://player.vimeo.com/video/1127953488?h=fa03b121ab"],
      mariajulia: ["https://player.vimeo.com/video/1127953679?h=64ac25eb5b", "https://player.vimeo.com/video/1127953806?h=e5f9c16ea2", "https://player.vimeo.com/video/1127953854?h=9fab2adb65", "https://player.vimeo.com/video/1127953915?h=e1de5a6cce", "https://player.vimeo.com/video/1127953985?h=a27622f466", "https://player.vimeo.com/video/1127954168?h=addecd89dd"],
      pedro: ["https://player.vimeo.com/video/1127954807?h=1c9bc16a9d", "https://player.vimeo.com/video/1127954917?h=82b3740141", "https://player.vimeo.com/video/1127955029?h=c867038614", "https://player.vimeo.com/video/1127955098?h=b28418d310", "https://player.vimeo.com/video/1127955209?h=8c679e82b2", "https://player.vimeo.com/video/1127955268?h=71f440b63e", "https://player.vimeo.com/video/1127955339?h=fd6dbbfe81"]
    };
    var currentDiretor = null,
      currentIndex = 0,
      progressInterval = null,
      videoDuration = 10;
    function updateStorySteps() {
      var $steps = $("#story-steps").empty();
      if (!currentDiretor) return;
      stories[currentDiretor].forEach(function (_, i) {
        $steps.append($("<div>").addClass("story-step-dot" + (i === currentIndex ? " active" : "")));
      });
    }
    function closeStoryModal() {
      $("#modal-story").removeClass("active");
      $("#story-video").attr("src", "");
      clearInterval(progressInterval);
      $("#progress-bar").css("width", "0%");
    }
    function startProgressBar(duration) {
      var elapsed = 0,
        $bar = $("#progress-bar");
      $bar.css("width", "0%");
      progressInterval = setInterval(function () {
        elapsed += 0.1;
        $bar.css("width", Math.min(elapsed / duration * 100, 100) + "%");
        if (elapsed >= duration) {
          clearInterval(progressInterval);
          nextStory();
        }
      }, 100);
    }
    var durationCache = {};
    function getVimeoDuration(url, cb) {
      if (durationCache[url]) {
        return cb(durationCache[url]);
      }
      var match = url.match(/video\/(\d+)/);
      if (!match) return cb(10);
      var $iframe = $("<iframe>", {
        style: "display:none",
        src: "https://player.vimeo.com/video/" + match[1] + "?api=1&player_id=apiVimeo",
        id: "apiVimeo"
      }).appendTo("body");
      function onMsg(ev) {
        if (!ev.data || typeof ev.data !== "string") return;
        try {
          var d = JSON.parse(ev.data);
          if (d.event === "ready") $iframe[0].contentWindow.postMessage(JSON.stringify({
            method: "getDuration"
          }), "*");
          if (d.method === "getDuration") {
            window.removeEventListener("message", onMsg);
            $iframe.remove();
            cb(d.value);
          }
        } catch (e) {}
      }
      if (d.method === "getDuration") {
        durationCache[url] = d.value;
        window.removeEventListener("message", onMsg);
        $iframe.remove();
        cb(d.value);
      }
      window.addEventListener("message", onMsg);
    }
    function loadStoryVideo() {
      clearInterval(progressInterval);
      var url = stories[currentDiretor][currentIndex] + "&autoplay=1&background=1";
      $("#story-video").attr("src", url);
      updateStorySteps();
      setTimeout(function () {
        getVimeoDuration(url, function (d) {
          videoDuration = d || 10;
          startProgressBar(videoDuration);
        });
      }, 500);
    }
    function nextStory() {
      if (currentIndex < stories[currentDiretor].length - 1) {
        currentIndex++;
        loadStoryVideo();
      } else closeStoryModal();
    }
    function prevStory() {
      if (currentIndex > 0) {
        currentIndex--;
        loadStoryVideo();
      }
    }
    $(".diretor").on("click", function () {
      currentDiretor = $(this).data("diretor");
      currentIndex = 0;
      $("#modal-story").addClass("active");
      loadStoryVideo();
    });
    $(".close-modal").on("click", closeStoryModal);
    $("#next-story").on("click", nextStory);
    $("#prev-story").on("click", prevStory);
    $(document).on("keydown", function (e) {
      if (!$("#modal-story").hasClass("active")) return;
      if (e.key === "ArrowRight") nextStory();
      if (e.key === "ArrowLeft") prevStory();
    });
    $(window).on("click", function (e) {
      if (e.target === $("#modal-story")[0]) closeStoryModal();
    });
  }
  function initCustomOrderPage() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        if ($('script[src="' + src + '"]').length) {
          resolve();
          return;
        }
        var s = document.createElement("script");
        s.src = src;
        s.async = true;
        s.onload = resolve;
        s.onerror = function () {
          reject(new Error("Erro ao carregar " + src));
        };
        document.body.appendChild(s);
      });
    }
    var hasPage = $("body").hasClass("page-information-information");
    var hasSection = $(".information-content17").length > 0;
    var mesaImg = document.querySelector(".mesa-image");
    var ringWrapper = document.querySelector(".ring-wrapper");
    if (mesaImg && ringWrapper) {
      var positionRing = function positionRing() {
        var scale = mesaImg.getBoundingClientRect().width / imgOriginalWidth;
        ringWrapper.style.bottom = "0px";
        ringWrapper.style.width = ringOriginalWidth * scale + "px";
        ringWrapper.style.height = ringOriginalWidth * scale + "px";
      };
      var ringOriginalWidth = 370,
        imgOriginalWidth = 1920;
      mesaImg.addEventListener("load", positionRing);
      window.addEventListener("resize", positionRing);
      positionRing();
    }
    if (!hasPage || !hasSection) return;
    loadScript("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js").then(function () {
      if ("scrollRestoration" in history) history.scrollRestoration = "manual";
      $(window).on("load", function () {
        $(window).scrollTop(0);
      });
      var swipers = [];
      function initSwipers() {
        if (window.innerWidth >= 1024) {
          swipers.forEach(function (s) {
            s.destroy(true, true);
          });
          swipers = [];
          return;
        }
        if (swipers.length) return;
        [".mySwiperComoFunciona", ".tiposSwiper"].forEach(function (sel) {
          var el = document.querySelector(sel);
          if (el) swipers.push(new Swiper(sel, {
            spaceBetween: 24,
            speed: 600,
            pagination: {
              el: el.querySelector(".swiper-pagination"),
              clickable: true
            },
            breakpoints: {
              0: {
                slidesPerView: 1
              },
              768: {
                slidesPerView: 1
              }
            }
          }));
        });
      }
      window.addEventListener("load", initSwipers);
      window.addEventListener("resize", initSwipers);
      gsap.to([".title-container", ".ring-drawn", ".wrap-btn-iniciar"], {
        opacity: 1,
        duration: 1.5,
        stagger: 0.3,
        ease: "power2.out"
      });
      gsap.set(".ring-wrapper", {
        xPercent: -50,
        yPercent: -50,
        x: 0,
        y: 0,
        scale: 0.8
      });
      var btn = document.getElementById("btn-iniciar");
      if (!btn) return;
      btn.addEventListener("click", function () {
        btn.style.pointerEvents = "none";
        var heroRect = document.querySelector(".hero-container").getBoundingClientRect();
        var scaleTarget = Math.min(heroRect.width / 1400, 1) * 0.8;
        var tl = gsap.timeline({
          defaults: {
            ease: "expo.inOut"
          }
        });
        tl.set(".ring-wrapper .ring-real", {
          xPercent: 0,
          yPercent: 0,
          x: 0,
          y: 0,
          scale: 1
        }, 0);
        tl.set([".bg-mesa", ".bg-espuma"], {
          y: "100%"
        }, 0);
        tl.to(".bg-branco-color", {
          y: "-100%",
          duration: 1.8
        }, 0);
        tl.to(".word.left", {
          x: -80,
          y: -60,
          opacity: 0,
          duration: 1.2
        }, 0);
        tl.to(".word.right", {
          x: 80,
          y: -60,
          opacity: 0,
          duration: 1.2
        }, 0);
        tl.to(".wrap-btn-iniciar", {
          y: -40,
          opacity: 0,
          duration: 1
        }, 0.2);
        tl.to([".bg-mesa"], {
          y: "0%",
          duration: 1.8
        }, 0);
        tl.set(".ring-wrapper", {
          zIndex: 15
        }, 0.9);
        tl.to(".ring-drawn", {
          opacity: 0,
          duration: 0.4
        }, 0.8);
        tl.to(".ring-real", {
          opacity: 1,
          duration: 0.4
        }, 0.8);
        tl.to(".ring-wrapper", {
          x: -30,
          y: 60,
          scale: scaleTarget,
          duration: 3,
          ease: "expo.inOut"
        }, 0.2);
        tl.to(".texto-final", {
          y: 10,
          opacity: 1,
          duration: 1.2,
          ease: "expo.out"
        }, 1);
        tl.to(".faixa-bottom-vazada", {
          opacity: 1,
          y: 0,
          duration: 1.2
        }, 0.8);
        tl.add(function () {
          document.body.style.overflowY = "auto";
          document.body.style.overflowX = "hidden";
        }, 2);
      });
    });
  }
});

/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(0);
/******/ 	
/******/ })()
;